import { LOCALES } from "../constants";

const hu = {
  [LOCALES.HU]: {
    //All page
    "Página não encontrada": "Az oldal nem található",
    //LOGIN PAGE
    "login.Login": "Bejelentkezés",
    "login.Informe seu e-mail": "Adja meg e-mail címét",
    "login.E-mail inválido. Por favor, verifique": "Érvénytelen e-mail cím. Kérjük, ellenőrizze",
    "login.Senha": "Jelszó",
    "login.Sua senha deve possuir no mínimo 6 caracteres": "A jelszónak legalább 6 karakterből kell állnia",
    "login.Esqueci minha senha": "Elfelejtettem a jelszavamat",
    "login.ENTRAR": "BELÉPÉS",
    "login.CRIAR CONTA": "FIÓK LÉTREHOZÁSA",
    "login.Não foi possÍvel fazer o login. Verifique seus dados e tente novamente": "Nem sikerült bejelentkezni. Ellenőrizze adatait, és próbálja újra",
    "login.A PLATAFORMA IOK MUDOU!": "AZ IOK PLATFORM MEGVÁLTOZOTT!",
    "login.Não exibir este aviso novamente": "Ne jelenítse meg újra ezt az üzenetet",
    "login.Se você já possui um cadastro na antiga plataforma, ": "Ha már rendelkezik fiókkal a régi platformon, ",
    "login.clique aqui": "kattintson ide",
    "login. para": " a ",
    "login.migrar": "migráláshoz ",
    "login.seus dados e aproveitar toda a experiência IOK.": "adatai átviteléhez és az IOK teljes élményének kihasználásához.",
    "login.Sua conta não foi ativada. Por gentileza, verifique seu e-mail para realizar a ativação": "Fiókja még nincs aktiválva. Kérjük, ellenőrizze e-mailjét az aktiváláshoz",
    "login.PLATAFORMA EM MANUTENÇÃO": "A PLATFORM KARBANTARTÁS ALATT ÁLL",
    "login.ESTAMOS PREPARANDO A NOVA PLATAFORMA IOK E EM BREVE ELA ESTARÁ PRONTA!": "AZ ÚJ IOK PLATFORM ELŐKÉSZÍTÉSÉN DOLGOZUNK, ÉS HAMAROSAN ELÉRHETŐ LESZ!",
    "login.Migrar Conta": "Fiók migrálása",
    "login.Se você já possui um cadastro na antiga plataforma, clique aqui em Migrar Conta para migrar seus dados e aproveitar toda a experiência IOK": "Ha már rendelkezik fiókkal a régi platformon, kattintson a Fiók migrálása lehetőségre adatai átviteléhez és az IOK teljes élményének kihasználásához",
    "login.Política de privacidade": "Adatvédelmi szabályzat",
    "login.ENTENDI": "MEGÉRTETTEM",
    "login.Para melhorar a sua experiência na plataforma e oferecer serviços personalizados, utilizamos cookies.": "A platform használatának javítása és személyre szabott szolgáltatások nyújtása érdekében sütiket használunk.",
    "login.Ao utilizar a Plataforma IOK, você automaticamente concorda com seu uso.": "Az IOK Platform használatával automatikusan hozzájárul a sütik használatához.",
    "login.Senha incorreta! Duas tentativas restantes antes de ter o acesso à conta bloqueado.": "Helytelen jelszó! Még két próbálkozása maradt, mielőtt a fiók hozzáférése zárolásra kerül.",
    "login.Senha incorreta! Uma tentativa restantes antes de ter o acesso à conta bloqueado.": "Helytelen jelszó! Még egy próbálkozása maradt, mielőtt a fiók hozzáférése zárolásra kerül.",
    "login.Acesso bloqueado! Siga as instruções de recuperação de conta.": "A hozzáférés zárolva! Kövesse a fiók-helyreállítási útmutatót.",
    
    // REGISTER
    "DISTRIBUIDOR": "FORGALMAZÓ: Prática berendezések forgalmazója vagyok.",
    "REDE": "HÁLÓZAT: Egy hálózat tulajdonosa vagyok.",
    "DONO": "VÁLLALAT: Saját vállalkozásom van / egy hálózat része vagyok.",
    "register.Informe seu e-mail cadastrado na plataforma IOK anterior": "Adja meg a korábbi IOK platformon regisztrált e-mail címét",
    "register.E-mail inválido. Por favor, verifique": "Érvénytelen e-mail cím. Kérjük, ellenőrizze",
    "register.BUSCAR DADOS": "ADATOK KERESÉSE",
    "register.Nome da organização": "Szervezet neve",
    "register.Informe o nome de sua organização": "Adja meg szervezete nevét",
    "register.O campo nome da organização é obrigatório": "A szervezet neve kötelező mező",
    "register.Este nome já existe. Por favor, escolha outro": "Ez a név már létezik. Kérjük, válasszon másikat",
    "register.RECUPERAR CONTA": "FIÓK HELYREÁLLÍTÁSA",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA DE USUÁRIO. POR GENTILIZA, AGUARDE": "A SZERVEZET ADMINISZTRÁTORA E-MAILT KAP FELHASZNÁLÓI FIÓKJA AKTIVÁLÁSÁHOZ. KÉRJÜK, VÁRJON",
    "register.E-mail não encontrado": "Az e-mail cím nem található",
    "register.Digite seu e-mail da plataforma IOK antiga": "Adja meg a régi IOK platformhoz tartozó e-mail címét",
    "register.Não foi possível recuperar sua conta. Verifique seus dados e tente novamente": "Nem sikerült helyreállítani a fiókját. Ellenőrizze adatait, és próbálja újra",
    "register.Não foi possível recuperar seus dados. Verifique e tente novamente": "Nem sikerült helyreállítani az adatait. Ellenőrizze, és próbálja újra",
    "register.PROSSEGUIR": "TOVÁBB",
    "register.VOCÊ ESTÁ SOLICITANDO ACESSO PARA A ORGANIZAÇÃO:": "HOZZÁFÉRÉST KÉR A KÖVETKEZŐ SZERVEZETHEZ:",
    "register.COM O ADMINISTRADOR:": "AZ ADMINISZTRÁTOR:",
    "register.E-mail já cadastrado na plataforma. Informe um novo e-mail ou acesse a plataforma com o e-mail já cadastrado": "Az e-mail cím már regisztrálva van a platformon. Adjon meg egy másikat, vagy jelentkezzen be a már regisztrált címmel",
    "register.Empresa já cadastrada na plataforma. Por favor, informe o nome de uma nova empresa": "A vállalat már regisztrálva van a platformon. Kérjük, adjon meg egy új vállalatnevet",
    "register.VOCÊ NÃO RECONHECEU O USUÁRIO {userName} COMO PARTE DA SUA ORGANIZAÇÃO E POR ISSO A CONTA DELE FOI DELETADA.": "NEM ISMERTE FEL A(Z) {userName} FELHASZNÁLÓT A SZERVEZETE TAGJAKÉNT, EZÉRT A FIÓKJA TÖRLÉSRE KERÜLT.",
    "register.NÂO FOI POSSÍVEL DELETAR O USÁRIO {userName}. POR GENTILEZA, TENTE NOVAMENTE MAIS TARDE.": "NEM SIKERÜLT TÖRÖLNI A(Z) {userName} FELHASZNÁLÓT. KÉRJÜK, PRÓBÁLJA ÚJRA KÉSŐBB.",
    "register.CONFIRMAR": "MEGERŐSÍTÉS",
    "register.Não foi possível fazer o cadastro. Verifique seus dados e tente novamente": "Nem sikerült a regisztráció. Ellenőrizze adatait, és próbálja újra",
    "register.VOCÊ RECEBERÁ UM E-MAIL PARA CONCLUIR SEU CADASTRO E ATIVAR SUA CONTA DE ADMINISTRADOR": "E-MAILT FOG KAPNI A REGISZTRÁCIÓ BEFEJEZÉSÉHEZ ÉS AZ ADMINISZTRÁTORI FIÓK AKTIVÁLÁSÁHOZ",
    "register.Nome": "Név",
    "register.Informe seu nome": "Adja meg a nevét",
    "register.O campo nome é obrigatório": "A név mező kitöltése kötelező",
    "register.E-mail": "E-mail",
    "register.Informe seu e-mail": "Adja meg e-mail címét",
    "register.E-mail inválido. Por favor, verifique novamente": "Érvénytelen e-mail cím. Kérjük, ellenőrizze újra",
    "register.Telefone": "Telefonszám",
    "register.Informe seu telefone": "Adja meg telefonszámát",
    "register.Crie sua senha": "Hozza létre jelszavát",
    "register.Informe sua senha": "Adja meg jelszavát",
    "register.O campo senha deve conter no mínimo 6 caracteres": "A jelszónak legalább 6 karakterből kell állnia",
    "register.Confirme sua senha": "Erősítse meg jelszavát",
    "register.As senhas devem ser iguais": "A jelszavaknak meg kell egyezniük",
    "register.CRIAR CONTA": "FIÓK LÉTREHOZÁSA",
    "register.CONTA ATIVADA COM SUCESSO": "A FIÓK SIKERESEN AKTIVÁLVA",
    "register.ACESSAR": "BELÉPÉS",
    "register.NÃO FOI POSSÍVEL ATIVAR SUA CONTA": "NEM SIKERÜLT AKTIVÁLNI A FIÓKJÁT",
    "register.Digite seu telefone": "Adja meg telefonszámát",
    "register.AGUARDE ENQUANTO TRANSFERIMOS SEUS DADOS. ESTE PROCESSO DEVE LEVAR ALGUNS MINUTOS. CASO VOCÊ POSSUA UMA GRANDE QUANTIDADE DE DADOS, A TRANSFERÊNCIA PODE LEVAR ATÉ UMA HORA.": "KÉRJÜK, VÁRJON, AMÍG ÁTVISSZÜK AZ ADATAIT. EZ A FOLYAMAT NÉHÁNY PERCET VEHET IGÉNYBE. NAGY MENNYISÉGŰ ADAT ESETÉN AZ ÁTVITEL AKÁR EGY ÓRÁT IS IGÉNYBE VEHET.",
    "register.DADOS TRANSFERIDOS COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "AZ ADATOK ÁTVITELE SIKERESEN MEGTÖRTÉNT! KATTINTSON AZ ALÁBBI GOMBRA A PLATFORM ELÉRÉSÉHEZ.",
    "register.EMAIL INVÁLIDO. POR GENTILEZA, VERIFIQUE SE SUA CONTA JÁ FOI ATIVADA.": "ÉRVÉNYTELEN E-MAIL CÍM. KÉRJÜK, ELLENŐRIZZE, HOGY FIÓKJA AKTIVÁLVA LETT-E.",
    "register.Ainda não tenho uma organização. Criar": "Még nincs szervezetem. Létrehozás",
    "register.Informe o ID da organização": "Adja meg a szervezet azonosítóját",
    "register.O campo com ID é obrigatório": "Az azonosító mező kitöltése kötelező",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA. POR GENTILIZA, AGUARDE": "A SZERVEZET ADMINISZTRÁTORA E-MAILT KAP FIÓKJA AKTIVÁLÁSÁHOZ. KÉRJÜK, VÁRJON",
    "register.A nova plataforma IOK agora está dividida em organizações e possui diferentes tipos de conta, que ajudam a organizar melhor as grandes corporações, empresas e redes.": "Az új IOK platform szervezetekre van felosztva, és különböző fióktípusokat kínál, amelyek segítenek a nagyvállalatok, cégek és hálózatok jobb kezelésében.",
    "register.O administrador da minha organização já realizou a migração da conta e temos um ID. Desejo migrar meus dados de usuário.": "A szervezetem adminisztrátora már elvégezte a fiók migrációját, és rendelkezünk azonosítóval. Szeretném migrálni a felhasználói adataimat.",
    "register.Desejo migrar a conta da minha organização e me tornar o administrador.": "Szeretném migrálni a szervezetem fiókját és adminisztrátorrá válni.",
    "register.Conta da organização já migrada": "A szervezet fiókja már migrálva lett",
    "register.Migrar conta da organização": "Szervezeti fiók migrálása",
    "register.A nova plataforma IOK agora conta com novas formas de acesso - que são referentes ao tipo de organização em que você atua. O responsável pela sua organização deve migrar a conta principal da empresa, se tornando o administrador, enquanto o restante dos funcionários devem se vincular a ela pelo ID fornecido.": "Az új IOK platform új hozzáférési lehetőségeket kínál, amelyek a szervezet típusától függenek. A szervezet felelősének migrálnia kell a vállalat fő fiókját, így adminisztrátorrá válik, míg a többi alkalmazott a megadott azonosítóval csatlakozhat hozzá.",
    "register.ID informado não corresponde a nenhuma companhia. Verifique e tente novamente": "A megadott azonosító nem tartozik egyetlen vállalathoz sem. Ellenőrizze, és próbálja újra",
    
    //HOME
    "home.Menus disponíveis na plataforma": "A platformon elérhető menük",
    "home.Criados na plataforma": "A platformon létrehozva",
    "home.Recebidos dos fornos": "Sütőkből érkezett",
    "home.Equipamentos vinculados": "Kapcsolt berendezések",
    "home.Total de receitas cadastradas": "Regisztrált receptek összesen",
    "home.Receitas": "Receptek",
    "home.Receitas em menus": "Receptek a menükben",
    "home.Em menus": "Menükben",
    "home.Receitas salvas no Cookbook": "A Cookbookban mentett receptek",
    "home.No Cookbook": "A Cookbookban",
    "home.Atualizações": "Frissítések",
    "home.Copa": "Copa",
    "home.Rocket": "Rocket",
    "home.Single Mag": "Single Mag",
    "home.Versão instalada": "Telepített verzió",
    "home.Versão disponível": "Elérhető verzió",
    "home.Usuários cadastrados": "Regisztrált felhasználók",
    "home.Aceitação pendente": "Elfogadásra vár",
    "home.Atualizado": "Frissítve",
    "home.OLÁ": "ÜDVÖZÖLJÜK",
    "home.É muito bom ter você aqui!": "Örülünk, hogy itt van!",
    "home.Com a Plataforma IOK é possível administrar seus fornos de onde estiver, criar e gerenciar receitas e menus, fazer backups, analisar os dados de seus equipamentos e muito mais!": "Az IOK platformmal bárhonnan kezelheti sütőit, recepteket és menüket hozhat létre és kezelhet, biztonsági mentéseket készíthet, elemezheti berendezései adatait és még sok mást tehet!",
    "home.Conheça a plataforma": "Ismerje meg a platformot",
    "home.Taxa de erro por modelo": "Hibaarány modellenként",
    "home.Erro": "Hiba",
    "home.QUEREMOS SABER SUA OPINIÃO SOBRE": "SZERETNÉNK MEGISMERNI A VÉLEMÉNYÉT ERRŐL:",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a Plataforma {model} foi criado!": "Nagyra értékeljük véleményét, ezért készítettük el ezt az elégedettségi kérdőívet a(z) {model} platformról!",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a linha {model} foi criado!": "Nagyra értékeljük véleményét, ezért készítettük el ezt az elégedettségi kérdőívet a(z) {model} termékcsaládról!",
    "home.Suas respostas nos ajudarão a aprimorar nossos serviços, garantindo que continuemos a oferecer a você a melhor experiência possível.": "Válaszai segítenek szolgáltatásaink fejlesztésében, hogy továbbra is a lehető legjobb élményt nyújthassuk Önnek.",
    "home.Reserve uns minutinhos de seu dia e participe!": "Szánjon néhány percet a napjából és vegyen részt!",
    "home.Responder a pesquisa": "Kérdőív kitöltése",
    "home.Modelos em evidência": "Kiemelt modellek",
    "home.Modelos": "Modellek",
    "home.Total de equipamentos vinculados": "Kapcsolt berendezések összesen",
    "home.Total de equipamentos online": "Online berendezések összesen",
    "home.Equipamentos online": "Online berendezések",
    "home.Países com Prática": "Országok, ahol jelen van a Prática",
    "home.Países": "Országok",
    "home.Aguarde enquanto carregamos os dados": "Kérjük, várjon, amíg betöltjük az adatokat",
    "home.Quase lá! Aguarde um pouco mais": "Már majdnem kész! Kérjük, várjon még egy kicsit",
    "home.Vendas por Equipamento": "Értékesítések berendezésenként",
    "home.Total de equipamentos vendidos": "Eladott berendezések összesen",
    "home.Equipamentos vendidos": "Eladott berendezések",
    "home.Clique para atualizar o software": "Kattintson a szoftver frissítéséhez",
    "home.Aceitação de software pendente": "Szoftver elfogadása függőben",
    "home.Software atualizado": "Szoftver frissítve",
    "home.NENHUM EQUIPAMENTO VINCULADO": "NINCS KAPCSOLT BERENDEZÉS",
    "home.FORNOS LIGADOS": "BEKAPCSOLT SÜTŐK",
    "home.Enviando dados": "Adatküldés",
    "home.Sem envio de dados": "Adatküldés nélkül",
    "home.Criados na Plataforma": "A platformon létrehozva",
    "home.Apenas no Cookbook": "Csak a Cookbookban",
    "home.Usuários na companhia": "Felhasználók a vállalatnál",
    "home.Inativos": "Inaktívak",
    "home.Online": "Online",
    "home.Atualizações de equipamentos": "Berendezésfrissítések",
    "home.Modelos de equipamentos": "Berendezésmodellek",
    "home.Atualizados": "Frissítettek",
    "home.Aguardando Aceite": "Elfogadásra vár",
    "home.Desatualizados": "Elavultak",
    "home.Versão": "Verzió",
    "home.Recente": "Legújabb",
    "home.Legenda": "Jelmagyarázat",
    "home.Chat": "Támogatás",
    
    //MAIN
    "main.HOME": "KEZDŐLAP",
    "main.COOKBOOK": "COOKBOOK",
    "main.MEUS MENUS": "MENÜIM",
    "main.EQUIPAMENTOS": "BERENDEZÉSEK",
    "main.USUÁRIOS": "FELHASZNÁLÓK",
    "main.ATENDIMENTOS": "SZERVIZKÉRÉSEK",
    "main.Idioma": "Nyelv",
    "main.Editar conta": "Fiók szerkesztése",
    "main.Configurações": "Beállítások",
    "main.Sair": "Kilépés",
    "main.Configurações salvas com sucesso!": "A beállítások sikeresen mentve!",
    "main.SALVAR": "MENTÉS",
    "main.CONFIGURAÇÕES": "BEÁLLÍTÁSOK",
    "main.Tema dark": "Sötét téma",
    "main.Notificações": "Értesítések",
    "main.Informações para as receitas": "Receptek beállításai",
    "main.Peso:": "Súly:",
    "main.Gramas": "Gramm",
    "main.Oz": "Uncia",
    "main.Temperatura:": "Hőmérséklet:",
    "main.Fahrenheit (°F)": "Fahrenheit (°F)",
    "main.Conta editada com sucesso!": "A fiók sikeresen frissítve!",
    "main.EDITAR CONTA": "FIÓK SZERKESZTÉSE",
    "main.Nome": "Név",
    "main.Preencha com o seu nome": "Adja meg a nevét",
    "main.Telefone": "Telefonszám",
    "main.Preencha com o seu telefone": "Adja meg a telefonszámát",
    "main.E-mail": "E-mail",
    "main.Preencha com o seu e-mail": "Adja meg az e-mail címét",
    "main.Alterar Senha": "Jelszó módosítása",
    "main.ALTERAR SENHA": "JELSZÓ MÓDOSÍTÁSA",
    "main.Senha atual": "Jelenlegi jelszó",
    "main.Nova senha": "Új jelszó",
    "main.Confirmar nova senha": "Új jelszó megerősítése",
    "main.Informe sua senha atual": "Adja meg jelenlegi jelszavát",
    "main.O campo senha deve conter no mínimo 6 caracteres": "A jelszónak legalább 6 karakterből kell állnia",
    "main.Informe sua nova senha": "Adja meg új jelszavát",
    "main.Confirme sua nova senha": "Erősítse meg új jelszavát",
    "main.Sua nova senha deve conter no mínimo 6 caracteres": "Az új jelszónak legalább 6 karakterből kell állnia",
    "main.INFORME SUA SENHA": "ADJA MEG JELSZAVÁT",
    "main.Informe sua senha para realizar a alteração de e-mail da plataforma:": "Adja meg jelszavát a platformon használt e-mail cím módosításához:",
    "main.CONFIRMAR": "MEGERŐSÍTÉS",
    "main.Existem campos que não foram preenchidos corretamente": "Néhány mező nincs megfelelően kitöltve",
    "main.Informe sua senha para prosseguir com a alteração de e-mail": "Az e-mail cím módosításának folytatásához adja meg jelszavát",
    "main.Senha alterada com sucesso": "A jelszó sikeresen módosítva",
    "main.Informe sua senha atual corretamente": "Adja meg helyesen jelenlegi jelszavát",
    "main.As senhas devem ser iguais": "A jelszavaknak meg kell egyezniük",
    "main.Nome do novo tipo de usuário": "Az új felhasználótípus neve",
    "main.Dê um nome para o novo tipo de usuário": "Adjon nevet az új felhasználótípusnak",
    "main.Token Desenvolvedor": "Fejlesztői token",
    "main.O Token Desenvolvedor é um código único e intransferível que permite a realização de alterações": "A fejlesztői token egy egyedi és nem átruházható kód, amely lehetővé teszi fejlesztői szintű módosítások végrehajtását közvetlenül a platform kódjában külső API-kon keresztül. Ezek segítségével a platform a vállalat igényeihez igazítható.",
    "main.É recomendado que estas alterações sejam realizadas por um profissional da área de tecnologia": "Ajánlott, hogy ezeket a módosításokat informatikai szakember végezze.",
    "main.Para acessar o token, informe sua senha": "A token eléréséhez adja meg jelszavát",
    "main.Copie e cole o token na autenticação de todas as requisições.": "Másolja ki és illessze be a tokent minden kérés hitelesítéséhez.",
    "main.Seu Token": "Az Ön tokenje",
    "main.Token copiado com sucesso!": "A token sikeresen másolva!",
    "main.Você deseja cancelar o preenchimento das informações?": "Meg szeretné szakítani az adatok kitöltését?",
    "main.Rever tutoriais": "Oktatóanyagok újraindítása",
    "main.Tutoriais resetados com sucesso!": "Az oktatóanyagok sikeresen visszaállítva!",
    "main.review.tutorials": "Szeretné újra megtekinteni az IOK platform oktatóanyagait?",
    "main.Procurar": "Keresés",
    "main.review.manual": "A kézikönyvet a számítógépére is elmentheti.",
    "main.review.download": "Kézikönyv megnyitása",
    
    //MEUS MENUS
    "menus.Procurar menu": "Menü vagy felhasználó keresése",
    "menus.Procurar menu excluído": "Törölt menü keresése",
    "menus.Menus": "Menük",
    "menus.Lixeira": "Kuka",
    "menus.CRIAR MENU": "MENÜ LÉTREHOZÁSA",
    "menus.IMPORTAR MENU": "MENÜ IMPORTÁLÁSA",
    "menus.Os arquivos serão mantidos na lixeira por 30 dias a contar de sua data de exclusão. Após este período, eles serão excluídos definitivamente.": "A fájlok a törlés dátumától számított 30 napig maradnak a Kukában. Ezen időszak után véglegesen törlésre kerülnek.",
    "menus.VOLTAR": "vissza",
    "menus.Compatível com: ": "Kompatibilis a következőkkel: ",
    "menus.Última atualização: ": "Utolsó frissítés: ",
    "menus.EXPORTAR MENU": "MENÜ EXPORTÁLÁSA",
    "menus.EDITAR MENU": "MENÜ SZERKESZTÉSE",
    "menus.Equipamentos associados": "Kapcsolt berendezések",
    "menus.Grupos": "Csoportok",
    "menus.Procurar grupo": "Csoport keresése",
    "menus.CRIAR GRUPO": "CSOPORT LÉTREHOZÁSA",
    "menus.receitas": "receptek",
    "menus.Nenhum grupo cadastrado": "Nincs regisztrált csoport",
    "menus.Nenhum menu cadastrado": "Nincs regisztrált menü",
    "menus.Nome": "Név",
    "menus.Modelo": "Modell",
    "menus.Atividade": "Tevékenység",
    "menus.Associação": "Hozzárendelés",
    "menus.Exportar": "Exportálás",
    "menus.Editar": "Szerkesztés",
    "menus.Excluir": "Törlés",
    "menus.Equips": "Ber.",
    "menus.Receitas": "Receptek",
    "menus.Compatibilidade": "Kompatibilitás",
    "menus.Última atualização": "Utolsó frissítés",
    "menus.Versão": "Verzió",
    "menus.Origem": "Forrás",
    "menus.Excluído por": "Törölte",
    "menus.Data de exclusão": "Törlés dátuma",
    "menus.Restaurar": "Visszaállítás",
    "menus.Existem campos que não foram preenchidos": "Vannak kitöltetlen mezők",
    "menus.Menu criado com sucesso!": "A menü sikeresen létrejött!",
    "menus.Existem campos com informações inválidas": "Vannak érvénytelen adatokat tartalmazó mezők",
    "menus.SALVAR": "MENTÉS",
    "menus.CANCELAR": "MÉGSE",
    "menus.Nome do menu": "Menü neve",
    "menus.Informe o nome do menu": "Adja meg a menü nevét",
    "menus.Preencha o nome do menu sem caracteres especiais": "Adja meg a menü nevét speciális karakterek nélkül",
    "menus.Apenas os caracteres @#%&*-+()!\"<>:;\\/?. são permitidos": "Csak a következő karakterek engedélyezettek: @#%&*-+()!\"<>:;\\/?.",
    "menus.Selecionar": "Kiválasztás",
    "menus.Idioma": "Nyelv",
    "menus.Temperatura de pré-aquec 1": "Előmelegítési hőmérséklet 1",
    "menus.Informe a temperatura de pré-aquec 1": "Adja meg az előmelegítési hőmérsékletet 1",
    "menus.Temperatura de pré-aquec 2": "Előmelegítési hőmérséklet 2",
    "menus.Informe a temperatura de pré-aquec 2": "Adja meg az előmelegítési hőmérsékletet 2",
    "menus.Tempo para estabilização": "Stabilizációs idő",
    "menus.Informe o tempo para estabilização": "Adja meg a stabilizációs időt",
    "menus.Desativar pré-aquec 2": "Előmelegítés 2 kikapcsolása",
    "menus.Configurações de data e hora": "Dátum- és időbeállítások",
    "menus.Data:": "Dátum:",
    "menus.DD/MM/AAAA": "NN/HH/ÉÉÉÉ",
    "menus.Hora:": "Idő:",
    "menus.24h": "24 órás",
    "menus.AM/PM": "AM/PM",
    "menus.EUR: DD/MM/AAAA": "EUR: NN/HH/ÉÉÉÉ",
    "menus.USA: MM/DD/AAAA": "USA: HH/NN/ÉÉÉÉ",
    "menus.ISO: AAAA/MM/DD": "ISO: ÉÉÉÉ/HH/NN",
    "menus.Seleção de acessos para habilitar": "Engedélyezendő hozzáférések kiválasztása",
    "menus.Modo manual": "Kézi mód",
    "menus.Habilitado": "Engedélyezve",
    "menus.Desabilitado": "Letiltva",
    "menus.Favoritos": "Kedvencek",
    "menus.Aquecer/Dourar": "Melegítés/Pirítás",
    "menus.Repetir receita": "Recept ismétlése",
    "menus.Configurações gerais do menu": "Általános menübeállítások",
    "menus.Temperatura:": "Hőmérséklet:",
    "menus.Fahrenheit (°F)": "Fahrenheit (°F)",
    "menus.Gramas": "Gramm",
    "menus.Oz": "Uncia (Oz)",
    "menus.Tema:": "Téma:",
    "menus.Dark": "Sötét",
    "menus.Light": "Világos",
    "menus.Introdução:": "Bevezető:",
    "menus.Ativada": "Aktiválva",
    "menus.Desativada": "Kikapcsolva",
    "menus.Menu deletado com sucesso!": "A menü sikeresen törölve!",
    "menus.Não foi possivel deletar o menu": "A menü törlése nem sikerült",
    "menus.Sim": "Igen",
    "menus.Não": "Nem",
    "menus.Excluir definitivamente": "Végleges törlés",
    "menus.SALVAR NO DISPOSITIVO": "MENTÉS AZ ESZKÖZRE",
    "menus.EXPORTAR": "EXPORTÁLÁS",
    "menus.Selecione os modelos e versões dos equipamentos que receberão o menu.": "Válassza ki azokat a berendezésmodelleket és verziókat, amelyek megkapják a menüt.",
    "menus.Forno": "Sütő",
    "menus.Fundo verde": "Zöld háttér",
    "menus.Fundo preto": "Fekete háttér",
    "menus.Linux": "Linux",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, exceto para menus de equipamentos Linux.": "Figyelem: mielőtt a menüt USB-meghajtóról a berendezésre másolná, ki kell csomagolnia a fájlt, kivéve a Linux-alapú berendezések menüit.",
    "menus.Selecione os equipamentos para os quais deseja exportar o menu.": "Válassza ki azokat a berendezéseket, amelyekre exportálni szeretné a menüt.",
    "menus.Nome do equipamento": "Berendezés neve",
    "menus.Selecionar todos": "Összes kijelölése",
    "menus.Selecionar todas": "Összes kijelölése",
    "menus.Categoria: ": "Kategória: ",
    "menus.Você deseja excluir o menu?": "Biztosan törölni szeretné a menüt?",
    "menus.O menu será deletado da plataforma, mas permanecerá no equipamento. Uma cópia de segurança será criada automaticamente e ficará disponível por 30 dias em Meus Menus - Lixeira.": "A menü törlésre kerül a platformról, de a berendezésen megmarad. Egy biztonsági másolat automatikusan létrejön, és 30 napig elérhető lesz a Saját menük - Kuka menüpontban.",
    "menus.Você deseja excluir o arquivo definitivamente?": "Biztosan véglegesen törölni szeretné a fájlt?",
    "menus.Esta ação não poderá ser desfeita.": "Ez a művelet nem vonható vissza.",
    "menus.Menu editado com sucesso!": "A menü sikeresen módosítva!",
    "menus.IMPORTAR": "IMPORTÁLÁS",
    "menus.VERIFICAÇÃO DE VERSÃO": "VERZIÓELLENŐRZÉS",
    "menus.Para conferir a versão da placa de seu equipamento, siga os seguintes passos:": "A berendezés panelverziójának ellenőrzéséhez kövesse az alábbi lépéseket:",
    "menus.No forno, acesse Configurações;": "A sütőn nyissa meg a Beállítások menüt;",
    "menus.Insira a senha 456789;": "Adja meg a 456789 jelszót;",
    "menus.Selecione a opção Sistema;": "Válassza a Rendszer opciót;",
    "menus.Selecione Informações do Fabricante;": "Válassza a Gyártói információk menüpontot;",
    "menus.O modelo de sua placa estará na linha Firmware IHM;": "A panel modellje az IHM Firmware sorban található;",
    "menus.1ª geração A": "1. generáció A",
    "menus.Firmware IHM: 12.3.4": "IHM Firmware: 12.3.4",
    "menus.1ª geração B": "1. generáció B",
    "menus.2ª geração/Linux:": "2. generáció/Linux:",
    "menus.Firmware IHM: L1.2.3": "IHM Firmware: L1.2.3",
    "menus.Selecione o modelo/versão do equipamento do qual deseja importar o menu. Saiba como conferir a versão de seu equipamento": "Válassza ki annak a berendezésnek a modelljét/verzióját, amelyről importálni szeretné a menüt. Tudja meg, hogyan ellenőrizheti a berendezés verzióját.",
    "menus.Como verificar a versão da placa": "A panel verziójának ellenőrzése",
    "menus.1° Geração": "1. generáció",
    "menus.Menu restaurado com sucesso!": "A menü sikeresen visszaállítva!",
    "menus.Não foi possivel restaurar o menu": "A menü visszaállítása nem sikerült",
    "menus.RESTAURAR ARQUIVO": "FÁJL VISSZAÁLLÍTÁSA",
    "menus.Você deseja restaurar o arquivo?": "Biztosan vissza szeretné állítani a fájlt?",
    "menus.O arquivo será restaurado como uma nova versão na plataforma, na guia Todos. Para salvá-lo no equipamento, exporte-o.": "A fájl új verzióként kerül visszaállításra a platformon, az Összes fül alatt. A berendezésre való mentéshez exportálja azt.",
    "menus.EXCLUIR MENU": "MENÜ TÖRLÉSE",
    "menus.Nenhum equipamento associado": "Nincs hozzárendelt berendezés",
    "menus.Nomeie o novo menu": "Adjon nevet az új menünek",
    "menus.Nomeie o novo grupo": "Adjon nevet az új csoportnak",
    "menus.Nome do grupo": "Csoport neve",
    "menus.Preencha o nome do grupo sem caracteres especiais": "Adja meg a csoport nevét speciális karakterek nélkül",
    "menus.Pré-aquecimento:": "Előmelegítés:",
    "menus.Grupo criado com sucesso!": "A csoport sikeresen létrejött!",
    "menus.SELECIONE UMA IMAGEM": "VÁLASSZON KI EGY KÉPET",
    "menus.SELECIONAR": "KIVÁLASZTÁS",
    "menus.Selecionar do dispositivo": "Kiválasztás az eszközről",
    "menus.Selecionar do banco de imagens": "Kiválasztás a képtárból",
    "menus.Formato .JPG ou .PNG": ".JPG vagy .PNG formátum",
    "menus.Procurar imagem": "Kép keresése",
    "menus.Pertence ao menu": "A menühöz tartozik",
    "menus.Alterar imagem": "Kép módosítása",
    "menus.Remover imagem": "Kép eltávolítása",
    "menus.EDITAR GRUPO": "CSOPORT SZERKESZTÉSE",
    "menus.Nome:": "Név:",
    "menus.CRIAR RECEITA": "RECEPT LÉTREHOZÁSA",
    "menus.SALVAR DO COOKBOOK": "MENTÉS A COOKBOOKBÓL",
    "menus.Procurar receita do grupo": "Csoport receptjének keresése",
    "menus.Ingrediente principal": "Fő összetevő",
    "menus.Limpar filtros": "Szűrők törlése",
    "menus.Filtrar": "Szűrés",
    "menus.Mover receitas": "Receptek áthelyezése",
    "menus.Excluir receitas": "Receptek törlése",
    "menus.Editar grupo": "Csoport szerkesztése",
    "menus.Excluir grupo": "Csoport törlése",
    "menus.aqui": "itt",
    "menus.Se o código possuir apenas números e o fundo da tela for verde, pertence à 1ª A, se possuir apenas números e o fundo da tela for preta, pertence à 1ª B e, se começar com as letras L, F ou S, sua placa pertence à 2ª geração/Linux.": "Ha a kód csak számokat tartalmaz, és a képernyő háttere zöld, akkor az 1A generációhoz tartozik; ha csak számokat tartalmaz és a háttér fekete, akkor az 1B generációhoz; ha pedig L, F vagy S betűvel kezdődik, akkor a panel a 2. generáció/Linux típusú.",
    "menus.1ª A - Fundo verde": "1A generáció - Zöld háttér",
    "menus.1ª B - Fundo preto": "1B generáció - Fekete háttér",
    "menus.2ª - Linux": "2. generáció - Linux",
    "menus.Tivemos um problema. Tente novamente mais tarde.": "Probléma történt. Kérjük, próbálja újra később.",
    "menus.Grupo editado com sucesso!": "A csoport sikeresen módosítva!",
    "menus.AINDA NÃO HÁ GRUPOS AQUI :(": "ITT MÉG NINCSENEK CSOPORTOK :(",
    "menus.description.AINDA NÃO HÁ GRUPOS AQUI :(": "Kattintson a jobb felső sarokban található gombra, és adjon hozzá csoportokat.",
    "menus.NENHUM MENU NA LIXEIRA": "NINCS MENÜ A KUKÁBAN",
    "menus.AINDA NÃO HÁ MENUS AQUI :(": "ITT MÉG NINCSENEK MENÜK :(",
    "menus.description.AINDA NÃO HÁ MENUS AQUI :(": "Kattintson a jobb felső sarokban található egyik gombra, és adjon hozzá menüket.",
    "menus.Adicionar imagem": "Kép hozzáadása",
    "menus.Nome da receita": "Recept neve",
    "menus.Detalhes da receita": "Recept részletei",
    "menus.Programação da receita": "Recept programozása",
    "menus.Nomeie sua receita": "Nevezze el a receptjét",
    "menus.Preencha o nome da receita sem caracteres especiais": "Adja meg a recept nevét speciális karakterek nélkül",
    "menus.Tipo de prato": "Étel típusa",
    "menus.SALVAR RECEITAS DO COOKBOOK": "RECEPTEK MENTÉSE A COOKBOOKBÓL",
    "menus.Selecione as receitas que deseja salvar no grupo de seu menu:": "Válassza ki azokat a recepteket, amelyeket el szeretne menteni a menü csoportjába:",
    "menus.Procurar receita": "Recept keresése",
    "menus.deleteGroupSuccess": "{count, plural, one {A csoport sikeresen törölve!} other {A csoportok sikeresen törölve!}}",
    "menus.deleteGroupError": "{count, plural, one {A csoport törlése nem sikerült.} other {A csoportok törlése nem sikerült.}}",
    "menus.EXCLUIR GRUPO": "CSOPORT TÖRLÉSE",
    "menus.confirmDeleteGroupMessage": "{count, plural, one {Biztosan véglegesen törölni szeretné a csoportot?} other {Biztosan véglegesen törölni szeretné a csoportokat?}}",
    "menus.AINDA NÃO HÁ RECEITAS AQUI :(": "ITT MÉG NINCSENEK RECEPTEK :(",
    "menus.description.AINDA NÃO HÁ RECEITAS AQUI :(": "Kattintson a jobb felső sarokban található egyik gombra, és adjon hozzá recepteket.",
    "menus.Temp. de entrada": "Bemeneti hőm.",
    "menus.Temp. de pré-aquec": "Előmelegítési hőm.",
    "menus.Ingredientes para montagem": "Összeállításhoz szükséges hozzávalók",
    "menus.Instruções operacionais": "Működési utasítások",
    "menus.Passo": "Lépés",
    "menus.Temp": "Hőm.",
    "menus.Temp.": "Hőm.",
    "menus.Tempo": "Idő",
    "menus.Velocidade do ar": "Légsebesség",
    "menus.Micro-ondas": "Mikrohullám",
    "menus.Resistência inferior": "Alsó fűtőelem",
    "menus.Informações": "Információk",
    "menus.Digite as informações do passo": "Adja meg a lépés információit",
    "menus.desativar": "kikapcsolás",
    "menus.Ingredientes": "Hozzávalók",
    "menus.Temperatura de entrada": "Bemeneti hőmérséklet",
    "menus.Equipamentos compatíveis": "Kompatibilis berendezések",
    "menus.Tempo total": "Teljes idő",
    "menus.SALVAR NO COOKBOOK": "MENTÉS A COOKBOOKBA",
    "menus.ver localização": "hely megtekintése",
    "menus.SELECIONE RECEITAS PARA EXCLUIR": "VÁLASSZA KI A TÖRLENDŐ RECEPTEKET",
    "menus.Você deseja excluir as receitas selecionadas definitivamente?": "Biztosan véglegesen törölni szeretné a kiválasztott recepteket?",
    "menus.Receitas deletadas com sucesso!": "A receptek sikeresen törölve!",
    "menus.Informe aqui os ingredientes para montagem": "Adja meg itt az összeállításhoz szükséges hozzávalókat",
    "menus.Informe aqui as instruções operacionais": "Adja meg itt a működési utasításokat",
    "menus.Adicionar passo": "Lépés hozzáadása",
    "menus.Receita criada com sucesso!": "A recept sikeresen létrehozva!",
    "menus.Ideal para:": "Ideális ehhez:",
    "menus.editar detalhes": "részletek szerkesztése",
    "menus.excluir": "törlés",
    "menus.editar": "szerkesztés",
    "menus.Receita editada com sucesso!": "A recept sikeresen módosítva!",
    "menus.Passo deletado com sucesso!": "A lépés sikeresen törölve!",
    "menus.Não foi possivel deletar o passo": "A lépés törlése nem sikerült",
    "menus.EXCLUIR PASSO": "LÉPÉS TÖRLÉSE",
    "menus.Você deseja excluir este passo?": "Biztosan törölni szeretné ezt a lépést?",
    "menus.Esta ação não poderá ser desfeita. Caso prefira, é possível apenas desativá-lo, mantendo assim sua configuração.": "Ez a művelet nem vonható vissza. Ha szeretné, egyszerűen le is tilthatja a lépést, így a beállításai megmaradnak.",
    "menus.Peso": "Súly",
    "menus.Origem da receita": "Recept eredete",
    "menus.Pré-aquecimento": "Előmelegítés",
    "menus.Plataforma": "Platform",
    "menus.Receita salva com sucesso!": "A recept sikeresen elmentve!",
    "menus.Exportar receitas": "Receptek exportálása",
    "menus.expandir": "kibontás",
    "menus.Temperatura": "Hőmérséklet",
    "menus.Vapor combinado": "Kombinált gőz",
    "menus.Ar quente": "Forró levegő",
    "menus.Sonda": "Szonda",
    "menus.Tempo (min)": "Idő (perc)",
    "menus.Umidade (%)": "Páratartalom (%)",
    "menus.Injeção de vapor": "Gőzbefecskendezés",
    "menus.Dumper aberto": "Nyitott csappantyú",
    "menus.Informe o peso": "Adja meg a súlyt",
    "menus.Informe a temperatura de entrada": "Adja meg a bemeneti hőmérsékletet",
    "menus.Informe os ingredientes para montagem": "Adja meg az összeállításhoz szükséges hozzávalókat",
    "menus.Informe as instruções operacionais": "Adja meg a működési utasításokat",
    "menus.Injeção de vapor (seg)": "Gőzbefecskendezés (mp)",
    "menus.Aquecer mais": "További melegítés",
    "menus.Dourar mais": "További pirítás",
    "menus.Aquecer e dourar mais": "További melegítés és pirítás",
    "menus.Favoritar receita": "Recept hozzáadása a kedvencekhez",
    "menus.Informe o tempo para aquecer mais": "Adja meg a további melegítés idejét",
    "menus.Informe o tempo para dourar mais": "Adja meg a további pirítás idejét",
    "menus.Informe o tempo para aquecer e dourar mais": "Adja meg a további melegítés és pirítás idejét",
    "menus.Apenas favoritos": "Csak kedvencek",
    "menus.Forno combinado": "Kombinált sütő",
    "menus.Cocção múltipla": "Többszörös sütés",
    "menus.Receitas Technicook": "Technicook receptek",
    "menus.Editar grupos": "Csoportok szerkesztése",
    "menus.Informe a data": "Adja meg a dátumot",
    "menus.Informe a hora": "Adja meg az időt",
    "menus.até 300": "legfeljebb 300",
    "menus.Vapor": "Gőz",
    "menus.Turbina": "Ventilátor",
    "menus.Criar grupo": "Csoport létrehozása",
    "menus.MOVER": "ÁTHELYEZÉS",
    "menus.Configurações de data e hora:": "Dátum- és időbeállítások:",
    "menus.Configurações de acessos:": "Hozzáférési beállítások:",
    "menus.Modo manual:": "Kézi mód:",
    "menus.Favoritos:": "Kedvencek:",
    "menus.Aquecer/dourar:": "Melegítés/pirítás:",
    "menus.Repetir receita:": "Recept ismétlése:",
    "menus.Configurações gerais do menu:": "Általános menübeállítások:",
    "menus.SELECIONE RECEITAS PARA MOVER": "VÁLASSZA KI AZ ÁTHELYEZENDŐ RECEPTEKET",
    "menus.AVANÇAR": "TOVÁBB",
    "menus.Selecione ou crie um grupo no mesmo menu para mover as receitas selecionadas ou as mova para outro menu. Note que apenas os menus/grupos compatíveis com as predefinições das receitas serão exibidos.": "Válasszon ki vagy hozzon létre egy csoportot ugyanabban a menüben a kiválasztott receptek áthelyezéséhez, vagy helyezze át őket egy másik menübe. Csak a receptek előbeállításaival kompatibilis menük/csoportok jelennek meg.",
    "menus.Mover receitas para o mesmo menu": "Receptek áthelyezése ugyanazon menün belül",
    "menus.Mover receitas para outro menu": "Receptek áthelyezése másik menübe",
    "menus.Selecionar grupo": "Csoport kiválasztása",
    "menus.Nenhuma receita foi selecionada": "Nincs kiválasztott recept",
    "menus.Passo editado com sucesso!": "A lépés sikeresen módosítva!",
    "menus.Menu atualizado": "Menü frissítve",
    "menus.até 260": "legfeljebb 260",
    "menus.Umidade na câmara": "Páratartalom a sütőtérben",
    "menus.Passos": "Lépések",
    "menus.ativar": "aktiválás",
    "menus.Informe a temperatura de pré-aquec": "Adja meg az előmelegítési hőmérsékletet",
    "menus.Movas as receitas selecionadas para outro menu. Note que apenas os menus compatíveis com as predefinições das receitas serão exibidos.": "Helyezze át a kiválasztott recepteket egy másik menübe. Csak a receptek előbeállításaival kompatibilis menük jelennek meg.",
    "menus.Sonda (°C)": "Szonda (°C)",
    "menus.Turbo Grill": "Turbo Grill",
    "menus.Pré-aquecimento padrão, conforme passo 1": "Alapértelmezett előmelegítés az 1. lépés szerint",
    "menus.salvar": "mentés",
    "menus.até": "legfeljebb",
    "menus.Verificação de receita": "Recept ellenőrzése",
    "menus.Auto import": "Automatikus importálás",
    "menus.Atualização forçada": "Kényszerített frissítés",
    "menus.Lista de receitas exportada com sucesso!": "A receptlista sikeresen exportálva!",
    "menus.Receita movida com sucesso!": "A recept sikeresen áthelyezve!",
    "menus.Receitas movidas com sucesso!": "A receptek sikeresen áthelyezve!",
    "menus.+ Menu": "+ Menü",
    "menus.+ Receita": "+ Recept",
    "menus.Selecione o modelo/versão do equipamento": "Válassza ki a berendezés modelljét/verzióját",
    "menus.Escolha um idioma compatível com o equipamento": "Válasszon a berendezéssel kompatibilis nyelvet",
    "menus.MENU IMPORTADO COM SUCESSO!": "A MENÜ SIKERESEN IMPORTÁLVA!",
    "menus.Dourar": "Pirítás",
    "menus.Não atribuir a menu": "Ne rendelje menühöz",
    "menus.Todos": "Összes",
    "menus.Meus menus": "Saját menük",
    "menus.Para salvar uma receita, preencha todos os campos": "A recept mentéséhez töltse ki az összes mezőt",
    "menus.Selecione os grupos de equipamentos para os quais deseja exportar o menu.": "Válassza ki azokat a berendezéscsoportokat, amelyekhez exportálni szeretné a menüt.",
    "menus.Formato inválido. São permitidos apenas os formatos .jpeg e .png": "Érvénytelen formátum. Csak a .jpeg és .png formátumok engedélyezettek.",
    "menus.Reordenar grupos": "Csoportok átrendezése",
    "menus.O que deseja fazer?": "Mit szeretne tenni?",
    "menus.Reordenar receitas": "Receptek átrendezése",
    "menus.ITENS REORDENADOS COM SUCESSO! PARA APLICAR AS ALTERAÇÕES NO FORNO, EXPORTE O MENU.": "AZ ELEMEK SIKERESEN ÁTRENDEZVE! A MÓDOSÍTÁSOK SÜTŐRE TÖRTÉNŐ ALKALMAZÁSÁHOZ EXPORTÁLJA A MENÜT.",
    "menus.ARRASTE OS ITENS PARA O LOCAL DESEJADO": "HÚZZA AZ ELEMEKET A KÍVÁNT HELYRE",
    "menus.Dumper": "Csappantyú",
    "menus.Aberto": "Nyitott",
    "menus.Fechado": "Zárt",
    "menus.Intermitente": "Szakaszos",
    "menus.Se o seu menu incluir itens sensíveis à uniformidade, recomendamos definir o Tempo de Estabilização entre 3:00 e 5:00 minutos. Caso contrário, você pode deixá-lo em 5 segundos.": "Ha a menü egyenletességre érzékeny termékeket tartalmaz, javasoljuk a stabilizációs idő 3:00 és 5:00 perc közé állítását. Ellenkező esetben 5 másodpercen hagyható.",
    "menus.Selecione o menu que deseja exportar:": "Válassza ki az exportálni kívánt menüt:",
    "menus.Temperatura de pré-aquecimento": "Előmelegítési hőmérséklet",
    "menus.Temperatura de lastro": "Sütőalj hőmérséklete",
    "menus.Temperatura de teto": "Tetőhőmérséklet",
    "menus.Volume de injeção de vapor (ml)": "Gőzbefecskendezés térfogata (ml)",
    "menus.Parada de turbina": "Ventilátor leállítása",
    "menus.Alta": "Magas",
    "menus.Média": "Közepes",
    "menus.Baixa": "Alacsony",
    "menus.a": "–",
    "menus.Valor da injeção": "Befecskendezési érték",
    "menus.Volume: até 999ml": "Térfogat: legfeljebb 999 ml",
    "menus.Tempo: até 15 segundos": "Idő: legfeljebb 15 másodperc",
    "menus.Tempo de injeção de vapor (seg)": "Gőzbefecskendezés ideje (mp)",
    "menus.Atenção!": "Figyelem!",
    "menus.Verifique as receitas do menu e ajuste os valores da Injeção de Vapor após alterar sua unidade de medida.": "Ellenőrizze a menü receptjeit, és módosítsa a gőzbefecskendezés értékeit a mértékegység megváltoztatása után.",
    "menus.Certifique-se de que a unidade de temperatura (°C ou °F) definida no equipamento seja a mesma que foi selecionada na criação do menu:": "Győződjön meg arról, hogy a berendezésen beállított hőmérsékleti egység (°C vagy °F) megegyezik a menü létrehozásakor kiválasztottal:",
    "menus.Injeção desativada": "Befecskendezés kikapcsolva",
    "menus.Selecione a unidade de temperatura que está definida no equipamento:": "Válassza ki a berendezésen beállított hőmérsékleti egységet:",
    "menus.Clique para atualizar": "Kattintson a frissítéshez",
    "menus.A função Atualização Forçada envia automaticamente o menu para os equipamentos selecionados, e que possuam versão compatível com este tipo de atualização, na próxima vez em que forem ligados. Os fornos que não estiverem atualizados ainda precisarão realizar o aceite manual.": "A Kényszerített frissítés funkció automatikusan elküldi a menüt a kiválasztott, ezzel a frissítési típussal kompatibilis berendezésekre a következő bekapcsoláskor. Azoknál a sütőknél, amelyek még nem frissítettek, továbbra is manuális jóváhagyás szükséges.",
    "menus.As opções selecionadas estarão disponíveis nos equipamentos que receberem este menu, podendo ser utilizadas pelo operador. É possível alterar estas configurações posteriormente no próprio forno ou pela plataforma.": "A kiválasztott opciók elérhetők lesznek azokon a berendezéseken, amelyek megkapják ezt a menüt, és a kezelő használhatja őket. Ezek a beállítások később a sütőn vagy a platformon is módosíthatók.",
    "menus.Não foi possivel deletar as receitas": "Nem sikerült törölni a recepteket",
    "menus.PRÉ": "ELŐ",
    "menus.Speed Ovens": "Speed sütők",
    "menus.Fornos Combinados": "Kombinált sütők",
    "menus.Fornos de Panificação": "Pékségi sütők",
    "menus.Após a criação, o tipo do menu não pode ser alterado. Ele só pode ser definido no momento da criação.": "Létrehozás után a menü típusa nem módosítható. Csak a létrehozás pillanatában határozható meg.",
    "menus.Pré-aquecimento do grupo": "Csoport előmelegítése",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, transferindo a pasta PRATICA para o equipamento.": "Figyelem: mielőtt a menüt az USB-meghajtóról a berendezésre másolná, ki kell csomagolnia a fájlt, és a PRATICA mappát kell átmásolnia a berendezésre.",
    "menus.Tamanho máximo": "Maximális méret",
    "menus.Possibilita que o operador do forno crie parâmetros e os execute em seguida.": "Lehetővé teszi, hogy a sütő kezelője paramétereket hozzon létre és azonnal végrehajtsa azokat.",
    "menus.Acesso também à execução das receitas favoritas.": "Hozzáférést biztosít a kedvenc receptek futtatásához is.",
    "menus.Possibilita que o operador adicione mais tempo para aquecer/dourar a refeição depois de sua execução.": "Lehetővé teszi, hogy a kezelő a végrehajtás után további időt adjon az étel melegítéséhez/pirításához.",
    "menus.Possibilita a repetição da receita assim que sua execução é finalizada.": "Lehetővé teszi a recept azonnali megismétlését a végrehajtás befejezése után.",
    "menus.Acesso exclusivo às receitas favoritas.": "Kizárólagos hozzáférés a kedvenc receptekhez.",
    "menus.Habilita o lembrete para o operador conferir se o alimento já está dentro do forno.": "Emlékeztetőt aktivál a kezelő számára annak ellenőrzésére, hogy az étel a sütőben van-e.",
    "menus.O forno importa automaticamente, ao ligar, um menu que esteja salvo em pen drive e nele inserido.": "A sütő bekapcsoláskor automatikusan importálja a behelyezett USB-meghajtón található menüt.",
    "menus.Possibilita a cocção de diversos alimentos simultaneamente, um em cada GN.": "Lehetővé teszi több étel egyidejű sütését, egy-egy GN-edényben.",
    "menus.Permite a execução de receitas pré programadas, vindas de fábrica.": "Lehetővé teszi a gyárilag előre programozott receptek futtatását.",
    "menus.Permite acesso à função turbo grill, que atinge até 300°C.": "Hozzáférést biztosít a Turbo Grill funkcióhoz, amely akár 300°C-ot is elér.",
    "menus.Possibilita que o operador adicione mais tempo para dourar a refeição depois de sua execução.": "Lehetővé teszi, hogy a kezelő a végrehajtás után további időt adjon az étel pirításához.",
    "menus.Permite que o operador edite grupos de receitas diretamente da tela inicial.": "Lehetővé teszi a kezelő számára, hogy közvetlenül a kezdőképernyőről szerkessze a receptcsoportokat.",
    "menus.Copiar grupos": "Csoportok másolása",
    "menus.Excluir grupos": "Csoportok törlése",
    "menus.Copiar": "Másolás",
    "menus.Selecione grupos para copiar": "Válassza ki a másolandó csoportokat",
    "menus.Selecione o destino dos grupos": "Válassza ki a csoportok célhelyét",
    "menus.Colar": "Beillesztés",
    "menus.Deseja cancelar a cópia e envio de grupos para os menus?": "Meg szeretné szakítani a csoportok másolását és elküldését a menükbe?",
    "menus.Grupos colados com sucesso": "{count, plural, one {A csoport sikeresen beillesztve!} other {A csoportok sikeresen beillesztve!}}",
    "menus.Copiar receitas": "Receptek másolása",
    "menus.Selecione receitas para copiar": "Válassza ki a másolandó recepteket",
    "menus.Selecione o destino das receitas": "Válassza ki a receptek célhelyét",
    "menus.Deseja cancelar a cópia e envio de receitas para os grupos?": "Meg szeretné szakítani a receptek másolását és elküldését a csoportokhoz?",
    "menus.Receitas coladas com sucesso": "{count, plural, one {A recept sikeresen beillesztve!} other {A receptek sikeresen beillesztve!}}",
    "menus.Converter para C-MAX EVO": "Konvertálás C-MAX EVO formátumba",
    "menus.Uma cópia deste menu, adaptada para o C-MAX EVO, será criada. Recomendamos que revise cuidadosamente todos os parâmetros dos passos e atualize as receitas com novas imagens, se julgar necessário.": "Létrejön ennek a menünek egy C-MAX EVO-hoz igazított másolata. Javasoljuk, hogy alaposan ellenőrizze az összes lépés paraméterét, és szükség esetén frissítse a receptek képeit.",
    "menus.Menu convertido com sucesso!": "A menü sikeresen konvertálva!",
    "menus.Não foi possível converter o menu. Tente novamente mais tarde": "A menü konvertálása nem sikerült. Kérjük, próbálja újra később.",
    "menus.O menu está sendo convertido... Aguarde!": "A menü konvertálása folyamatban van... Kérjük, várjon!",
    "menus.Menu incompatível com": "A menü nem kompatibilis ezzel:",
    "menus.Selecione pelo menos um grupo": "Válasszon ki legalább egy csoportot",
    "menus.Selecione pelo menos um menu": "Válasszon ki legalább egy menüt",
    "menus.Menu atual": "Jelenlegi menü",
    "menus.Copiando grupos": "{count, plural, one {A csoport másolása folyamatban van... Kérjük, várjon!} other {A csoportok másolása folyamatban van... Kérjük, várjon!}}",
    "menus.Erro ao copiar grupos": "{count, plural, one {A csoport másolása nem sikerült. Kérjük, próbálja újra később!} other {A csoportok másolása nem sikerült. Kérjük, próbálja újra később!}}",
    "menus.Procurar pelo nome do menu": "Keresés menünév alapján",
    "menus.Escolha um grupo de destino para cada menu selecionado": "Válasszon célcsoportot minden kijelölt menühöz!",
    "menus.Copiando receitas": "{count, plural, one {A recept másolása folyamatban van... Kérjük, várjon!} other {A receptek másolása folyamatban van... Kérjük, várjon!}}",
    "menus.Erro ao copiar receitas": "{count, plural, one {A recept másolása nem sikerült. Kérjük, próbálja újra később!} other {A receptek másolása nem sikerült. Kérjük, próbálja újra később!}}",
    "menus.SELECIONE GRUPOS PARA EXCLUIR": "VÁLASSZA KI A TÖRLENDŐ CSOPORTOKAT",
    "menus.Padeiro noturno": "Éjszakai pék",
    "menus.Permite programar o início (pré-aquecimento) de uma receita específica ou informada manualmente (Modo Manual), sem a necessidade de presença de um operador no local.": "Lehetővé teszi egy adott vagy kézzel megadott recept (Kézi mód) indításának (előmelegítésének) ütemezését anélkül, hogy kezelőnek a helyszínen kellene lennie.",
    "menus.Vaporizador": "Gőzölő",
    "menus.Editar receitas": "Receptek szerkesztése",
    "menus.Permite que o operador edite receitas diretamente da tela inicial.": "Lehetővé teszi a kezelő számára a receptek közvetlen szerkesztését a kezdőképernyőről.",
    "menus.Preencha o nome da receita": "Adja meg a recept nevét",
    "menus.Tempo nível": "Szintidő",
    "menus.Fermentadora": "Kelesztő",
    "menus.0 ou 5 a 59s": "0 vagy 5–59 mp",
    "menus.Selecione uma imagem": "Válasszon képet",
    "menus.*Para criar receitas para fornos sem conectividade, crie um menu e então as receitas.": "*Kapcsolat nélküli sütőkhöz először hozzon létre egy menüt, majd a recepteket.",
    "menus.CONVERTER": "KONVERTÁLÁS",
    "menus.Converter para FIT": "Konvertálás FIT formátumba",
    "menus.Converter para outro FIT": "Konvertálás másik FIT modellre",
    "menus.Selecione pelo menos um modelo FIT": "Válasszon ki legalább egy FIT modellt",
    "menus.O menu está sendo convertido para FIT... Aguarde!": "A menü FIT formátumba konvertálása folyamatban van... Kérjük, várjon!",
    "menus.{count} menu(s) convertido(s) com sucesso para FIT!": "{count} menü sikeresen konvertálva FIT formátumba!",
    "menus.Alguns menus foram convertidos, mas houve falha em: {models}": "Néhány menü konvertálása sikeres volt, de hiba történt a következőknél: {models}",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos.": "A kiválasztott FIT modellek mindegyikéhez létrejön ennek a menünek egy másolata, megtartva a beállításokat, csoportokat, recepteket és lépéseket.",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos. No entanto, como cada forno possui dimensões e características específicas, recomendamos revisar e ajustar os parâmetros para garantir o melhor desempenho e resultado em cada equipamento. Selecione o modelo da linha FIT para qual deseja converter o menu.": "A kiválasztott FIT modellek mindegyikéhez létrejön ennek a menünek egy másolata, megtartva a beállításokat, csoportokat, recepteket és lépéseket. Mivel azonban minden sütő sajátos méretekkel és jellemzőkkel rendelkezik, javasoljuk a paraméterek átvizsgálását és módosítását a legjobb teljesítmény és eredmény érdekében. Válassza ki azt a FIT modellt, amelyre a menüt konvertálni szeretné.",
    
    //COOKBOOK
    "cookbook.RECEITAS DISPONÍVEIS": "ELÉRHETŐ RECEPTEK",
    "cookbook.RECEITAS SALVAS": "MENTETT RECEPTEK",
    "cookbook.ENVIAR PARA MENU": "KÜLDÉS MENÜBE",
    "cookbook.SALVAR": "MENTÉS",
    "cookbook.salvar": "mentés",
    "cookbook.Filtrar por": "Szűrés",
    "cookbook.Procurar receita do cookbook": "Recept keresése a Cookbookban",
    "cookbook.Equipamento": "Berendezés",
    "cookbook.Ingrediente principal": "Fő összetevő",
    "cookbook.Tipo de prato": "Étel típusa",
    "cookbook.Região": "Régió",
    "cookbook.Pré-aquecimento": "Előmelegítés",
    "cookbook.Procurar receita": "Recept keresése",
    "cookbook.Menu": "Menü",
    "cookbook.ENVIAR": "KÜLDÉS",
    "cookbook.Procurar nome do menu": "Menünév keresése",
    "cookbook.Escolha um grupo deste menu": "Válasszon egy csoportot ebből a menüből",
    "cookbook.Selecionar grupo": "Csoport kiválasztása",
    "cookbook.Tivemos um problema. Tente novamente mais tarde": "Hiba történt. Kérjük, próbálja újra később.",
    "cookbook.Receita adicionada com sucesso!": "A recept sikeresen hozzáadva!",
    "cookbook.Não foi possível adicionar a receita. Tente novamente mais tarde": "A recept hozzáadása nem sikerült. Kérjük, próbálja újra később.",
    "cookbook.Selecione um menu e um grupo para enviar esta receita": "Válasszon egy menüt és egy csoportot a recept elküldéséhez",
    "cookbook.A receita não foi adicionada ao menu pois não há grupos criados": "A recept nem került hozzáadásra a menühöz, mert nincs létrehozott csoport",
    "cookbook.Selecione o modelo do equipamento primeiro": "Először válassza ki a berendezés modelljét",
    "cookbook.Grupo": "Csoport",
    "cookbook.Não foi possível salvar os passos da receita": "A recept lépéseinek mentése nem sikerült",
    "cookbook.Bovina": "Marhahús",
    "cookbook.Frango": "Csirke",
    "cookbook.Ovos": "Tojás",
    "cookbook.Pães": "Kenyerek",
    "cookbook.Peixes": "Halak",
    "cookbook.Queijo": "Sajt",
    "cookbook.Suína": "Sertéshús",
    "cookbook.Vegetais": "Zöldségek",
    "cookbook.Outros": "Egyéb",
    "cookbook.Entradas/aperitivos": "Előételek/snackek",
    "cookbook.Principais": "Főételek",
    "cookbook.Snacks": "Snackek",
    "cookbook.Pizzas": "Pizzák",
    "cookbook.Massas": "Tésztafélék",
    "cookbook.Acompanhamentos": "Köretek",
    "cookbook.Sobremesas": "Desszertek",
    "cookbook.Manhã": "Reggeli",
    "cookbook.Padaria": "Pékség",
    "cookbook.Todos": "Összes",
    "cookbook.Não atribuir origem": "Nincs eredet megadva",
    "cookbook.Brasil": "Brazília",
    "cookbook.Alemanha": "Németország",
    "cookbook.França": "Franciaország",
    "cookbook.Rússia": "Oroszország",
    "cookbook.China": "Kína",
    "cookbook.Japão": "Japán",
    "cookbook.Itália": "Olaszország",
    "cookbook.Egito": "Egyiptom",
    "cookbook.Grécia": "Görögország",
    "cookbook.Argentina": "Argentína",
    "cookbook.África": "Afrika",
    "cookbook.Estados Unidos": "Egyesült Államok",
    "cookbook.Coreia": "Korea",
    "cookbook.Turquia": "Törökország",
    "cookbook.Ideal para": "Ideális",
    "cookbook.Polônia": "Lengyelország",
    "cookbook.Sanduíches": "Szendvicsek",
    "cookbook.Nova Receita": "Új recept",
    
    //EQUIPAMENTOS
    "equipment.equipamentos": "berendezések",
    "equipment.procurar equipamento": "Berendezés vagy felhasználó keresése",
    "equipment.adicionar equipamento": "berendezés hozzáadása",
    "equipment.atualizar equipamento": "berendezés frissítése",
    "equipment.+ equipamentos": "+ berendezések",
    "equipment.buscar equipamento": "Berendezés keresése",
    "equipment.Desvincular": "Leválasztás",
    "equipment.Editar": "Szerkesztés",
    "equipment.sem conteúdo": "MÉG NINCSENEK BERENDEZÉSEK ITT :(",
    "equipment.description.sem conteúdo": "Kattintson a jobb felső sarokban található Berendezés hozzáadása gombra, és kapcsolja össze sütőit.",
    "equipment.editar equipamento": "berendezés szerkesztése",
    "equipment.equipamento editado com sucesso!": "A berendezés sikeresen szerkesztve!",
    "equipment.não foi possível editar o equipamento. Tente novamente mais tarde": "A berendezés szerkesztése nem sikerült. Kérjük, próbálja újra később.",
    "equipment.Menu exportado com sucesso!": "A menü sikeresen exportálva!",
    "equipment.Não foi possível exportar o menu. Tente novamente mais tarde": "A menü exportálása nem sikerült. Kérjük, próbálja újra később.",
    "equipment.Selecione pelo menos um equipamento para enviar o menu": "Válasszon ki legalább egy berendezést a menü elküldéséhez",
    "equipment.Informações do menu": "Menüinformációk",
    "equipment.Procurar receita ou grupo": "Recept vagy csoport keresése",
    "equipment.Grupo": "Csoport",
    "equipment.Grupos de equipamentos": "Berendezéscsoportok",
    "equipment.Receita": "Recept",
    "equipment.Quantidade": "Mennyiség",
    "equipment.Receitas mais preparadas no equipamento durante o período": "A berendezésen a kiválasztott időszakban leggyakrabban futtatott receptek",
    "equipment.Informações de limpeza": "Tisztítási információk",
    "equipment.Data da limpeza": "Tisztítás dátuma",
    "equipment.Hora da limpeza": "Tisztítás ideje",
    "equipment.nome": "Név",
    "equipment.modelo": "Modell",
    "equipment.categoria": "Kategória",
    "equipment.loja": "Üzlet",
    "desvincular equipamento": "Berendezés leválasztása",
    "equipment.unlink.paragrafo 1": "Biztosan leválasztja a berendezést az IOK platformról?",
    "equipment.unlink.paragrafo 2": "Ezt követően a platformon keresztül már nem lesz lehetőség a beállítások és a menü kezelésére, hacsak nem kapcsolja újra a berendezést a csatlakoztatási útmutató szerint.",
    "equipamento desvinculado com sucesso!": "A berendezés sikeresen leválasztva!",
    "equipment.ocorreu um erro. Tente novamente mais tarde": "Hiba történt. Kérjük, próbálja újra később.",
    "equipment.sim": "Igen",
    "equipment.não": "Nem",
    "equipment.Encerrar acesso remoto": "Távoli hozzáférés lezárása",
    "equipment.Horas sem limpeza": "Tisztítás nélkül eltelt órák",
    "equipment.Histórico de eventos": "Eseménynapló",
    "equipment.Histórico de eventos do forno": "Sütő eseménynaplója",
    "equipment.Histórico de eventos da fermentadora": "Kelesztő eseménynaplója",
    "equipment.Receitas executadas": "Végrehajtott receptek",
    "equipment.Hoje": "Ma",
    "equipment.Tempo de porta aberta": "Nyitott ajtó ideje",
    "equipment.Tempo médio aproximado": "Becsült átlagos idő",
    "equipment.Filtrar eventos": "Események szűrése",
    "equipment.Evento": "Esemény",
    "equipment.Data": "Dátum",
    "equipment.ERRO SENSOR RI": "Alsó fűtőelem érzékelő hiba",
    "equipment.ERRO COM INV. DE FREQ.": "Frekvenciaváltó hiba",
    "equipment.ERRO MAGNETRON": "Magnetron hiba",
    "equipment.ERRO SENSOR CAMARA": "Kamraérzékelő hiba",
    "equipment.ERRO CAN": "CAN hiba",
    "equipment.Erro INVERSOR DE FREQUENCIA": "Frekvenciaváltó hiba",
    "equipment.ERRO DO MODELO DO EQUIPAMENTO": "Berendezésmodell hiba",
    "equipment.ERRO PAINEL": "Panel hiba",
    "equipment.ERRO INV.FREQ.STATUS": "Frekvenciaváltó állapothiba",
    "equipment.ERRO SENSOR BOARD": "Panelérzékelő hiba",
    "equipment.ERRO ENERGY": "Energiahiba",
    "equipment.ERRO I2C": "I2C hiba",
    "equipment.EQUIPAMENTO LIGADO": "Berendezés bekapcsolva",
    "equipment.EQUIPAMENTO DESLIGADO": "Berendezés kikapcsolva",
    "equipment.Plataforma": "Platform",
    "equipment.Forno": "Sütő",
    "equipment.Origem": "Forrás",
    "equipment.Locais": "Helyszínek",
    "equipment.não foi possível carregar as entidades": "Az entitások betöltése nem sikerült",
    "equipment.conceder acesso remoto a": "Távoli hozzáférés biztosítása:",
    "equipment.atualizar software": "szoftver frissítése",
    "equipment.suporte": "támogatás",
    "equipment.PIN": "PIN",
    "equipment.nome do equipamento": "Berendezés neve",
    "equipment.vinculado à loja": "Üzlethez kapcsolva",
    "equipment.cadastrar loja": "Üzlet regisztrálása",
    "equipment.informe o PIN do forno": "Adja meg a sütő PIN-kódját",
    "equipment.preencha o PIN do forno": "Töltse ki a sütő PIN-kódját",
    "equipment.adicione um nome para facilitar seu reconhecimento": "Adjon meg egy nevet a könnyebb azonosítás érdekében",
    "equipment.preencha o nome do equipamento": "Töltse ki a berendezés nevét",
    "equipment.selecionar": "Kiválasztás",
    "equipment.nome fantasia": "Kereskedelmi név",
    "equipment.informe o nome fantasia": "Adja meg a kereskedelmi nevet",
    "equipment.preencha o nome fantasia": "Töltse ki a kereskedelmi nevet",
    "equipment.CNPJ": "CNPJ",
    "equipment.XX.XXX.XXX/0001.XX": "XX.XXX.XXX/0001.XX",
    "equipment.preencha o CNPJ": "Töltse ki a CNPJ-t",
    "equipment.CEP": "Irányítószám",
    "equipment.00000-000": "00000-000",
    "equipment.preencha o CEP": "Töltse ki az irányítószámot",
    "equipment.cidade": "Város",
    "equipment.informe a cidade": "Adja meg a várost",
    "equipment.preencha a cidade": "Töltse ki a várost",
    "equipment.UF": "Állam",
    "equipment.bairro": "Városrész",
    "equipment.informe o bairro": "Adja meg a városrészt",
    "equipment.endereço": "Cím",
    "equipment.informe o seu endereço": "Adja meg a címét",
    "equipment.preencha o seu endereço": "Töltse ki a címét",
    "equipment.Nº": "Sz.",
    "equipment.equipamento cadastrado com sucesso!": "A berendezés sikeresen regisztrálva!",
    "equipment.ocorreu um erro": "Hiba történt",
    "equipment.preencha o modelo": "Töltse ki a modellt",
    "equipment.selecione uma categoria": "Válasszon kategóriát",
    "equipment.selecione uma loja": "Válasszon üzletet",
    "equipment.preencha o bairro": "Töltse ki a városrészt",
    "equipment.não foi possível cadastrar o equipamento. Tente novamente mais tarde": "A berendezés regisztrálása nem sikerült. Kérjük, próbálja újra később.",
    "equipment.loja cadastrada com sucesso": "Az üzlet sikeresen regisztrálva",
    "equipment.não foi possível cadastrar a loja. Tente novamente mais tarde": "Az üzlet regisztrálása nem sikerült. Kérjük, próbálja újra később.",
    "equipment.equipment": "berendezések",
    "equipment.search equipment": "berendezés keresése",
    "equipment.add equipment": "berendezés hozzáadása",
    "equipment.update equipment": "berendezés frissítése",
    "equipment.plus equipment": "+ berendezés",
    "equipment.Procurar equipamento": "Berendezés keresése",
    "equipment.EQUIPAMENTOS": "BERENDEZÉSEK",
    "equipment.Atualizar equipamento": "Berendezés frissítése",
    "equipment.Atualizar equipamentos": "Berendezések frissítése",
    "equipment.confirmar": "megerősítés",
    "equipment.Selecione os modelos que deseja atualizar:": "Válassza ki a frissíteni kívánt modelleket:",
    "equipment.Como deseja realizar a atualização?": "Hogyan szeretné végrehajtani a frissítést?",
    "equipment.Enviar atualização pela plataforma (internet)": "Frissítés küldése a platformon keresztül (internet)",
    "equipment.Salvar arquivo de atualização no dispositivo": "Frissítési fájl mentése az eszközre",
    "equipment.Linha Express": "Express termékcsalád",
    "equipment.Escolha como deseja realizar a atualização": "Válassza ki a frissítés módját",
    "equipment.Selecione ao menos um modelo de equipamento para atualizar": "Válasszon ki legalább egy frissítendő berendezésmodellt",
    "equipment.Status: ": "Állapot: ",
    "equipment.Número de série:": "Sorozatszám:",
    "equipment.Menu:": "Menü:",
    "equipment.Status:": "Állapot:",
    "equipment.Número de série": "Sorozatszám",
    "equipment.Menu": "Menü",
    "equipment.Loja: ": "Üzlet: ",
    "equipment.End:": "Cím:",
    "equipment.Endereço:": "Cím: ",
    "equipment.Cidade:": "Város: ",
    "equipment.CEP:": "Irányítószám: ",
    "equipment.Atualização de software enviada com sucesso!": "A szoftverfrissítés sikeresen elküldve!",
    "equipment.Não foi possível enviar a atualização de software. Tente novamente mais tarde": "A szoftverfrissítés elküldése nem sikerült. Kérjük, próbálja újra később.",
    "equipment.Download realizado com sucesso": "A letöltés sikeresen befejeződött",
    "equipment.Não foi possível realizar o download. Tente novamente mais tarde": "A letöltés nem sikerült. Kérjük, próbálja újra később.",
    "equipment.Solicitação processada com erro. Tente novamente mais tarde": "A kérés feldolgozása során hiba történt. Kérjük, próbálja újra később.",
    "equipment.Preencha o nome da versão": "Adja meg a verzió nevét",
    "equipment.Informe aqui todas as alterações desta nova versão": "Sorolja fel itt az új verzió összes módosítását",
    "equipment.Nova versão de software atualizada com sucesso!": "Az új szoftververzió sikeresen frissítve!",
    "equipment.Informe pelo menos uma mudança nesta versão": "Adjon meg legalább egy módosítást ebben a verzióban",
    "equipment.Falha ao transformar o arquivo em Blob": "Nem sikerült a fájlt Blob objektummá alakítani",
    "equipment.Erro ao criar Blob a partir do arquivo": "Hiba történt a Blob létrehozásakor a fájlból",
    "equipment.Falha ao ler o arquivo": "Nem sikerült beolvasni a fájlt",
    "equipment.selecionar tipo": "típus kiválasztása",
    "equipment.selecione o tipo da versão": "válassza ki a verzió típusát",
    "equipment.atualização": "FRISSÍTÉS",
    "equipment.Selecione abaixo o que deseja fazer:": "Válassza ki alább, mit szeretne tenni:",
    "equipment.Atualizar meus equipamentos": "Berendezéseim frissítése",
    "equipment.Enviar atualização para usuários selecionados": "Frissítés küldése a kiválasztott felhasználóknak",
    "equipment.ENVIAR": "KÜLDÉS",
    "equipment.ENVIAR ATUALIZAÇÃO": "FRISSÍTÉS KÜLDÉSE",
    "equipment.Selecione os e-mails para os quais deseja enviar a atualização:": "Válassza ki az e-mail címeket, amelyekre a frissítést küldeni szeretné:",
    "equipment.A atualização disponibilizada no dia": "A következő napon közzétett frissítés:",
    "equipment.referente ao equipamento": "a következő berendezéshez:",
    "equipment.contempla o seguinte:": "a következőket tartalmazza:",
    "equipment.Selecionar arquivo para envio": "Fájl kiválasztása feltöltéshez",
    "equipment.Por favor, selecione um arquivo .tar": "Kérjük, válasszon egy .tar fájlt",
    "equipment.Selecione o modelo do equipamento:": "Válassza ki a berendezés modelljét:",
    "equipment.Selecione uma opção": "Válasszon egy lehetőséget",
    "equipment.Nomeie a versão": "Nevezze el a verziót",
    "equipment.Clique sobre o arquivo que deseja baixar:": "Kattintson a letölteni kívánt fájlra:",
    "equipment.Baixar atualização": "Frissítés letöltése",
    "equipment.Versões": "Verziók",
    "equipment.e superiores": "és újabbak",
    "equipment.name": "név",
    "equipment.model": "modell",
    "equipment.category": "kategória",
    "equipment.store": "üzlet",
    "FIT Express/FIT ST": "FIT Express/FIT ST",
    "Copa/Single Mag/Rocket": "Copa/Single Mag/Rocket",
    "Forza STi": "Forza STi",
    "TSi": "TSi",
    "FIT Express": "FIT Express",
    "FIT ST": "FIT ST",
    "FIT Express, FIT ST": "FIT Express, FIT ST",
    "Copa Express, Rocket Express, Copa Single Mag": "Copa Express, Rocket Express, Copa Single Mag",
    "equipment.e": "és",
    "equipment.Últimas versões de software:": "Legfrissebb szoftververziók:",
    "equipment.Você não possui nenhum equipamento desatualizado": "Nincs elavult berendezése",
    "equipment.grupos": "csoportok",
    "equipment.não foi possível carregar os grupos de equipamentos da companhia": "A vállalat berendezéscsoportjainak betöltése nem sikerült",
    "equipment.vinculado ao grupo": "Csoporthoz rendelve",
    "equipment.selecione um grupo": "Válasszon egy csoportot",
    "equipment.cadastrar grupo": "Csoport létrehozása",
    "equipment.Número de Série": "SN",
    "equipment.Versão": "Verzió",
    "equipment.não foi possível cadastrar o equipamento. Selecione ou cadastre um grupo": "A berendezés regisztrálása nem sikerült. Válasszon vagy hozzon létre egy csoportot",
    "equipment.CRIE GRUPOS DE EQUIPAMENTOS!": "HOZZON LÉTRE BERENDEZÉSCSOPORTOKAT!",
    "equipment.Para que os usuários vinculados à conta possam visualizar os equipamentos você precisa:": "Ahhoz, hogy a fiókhoz rendelt felhasználók láthassák a berendezéseket, a következőkre van szükség:",
    "equipment.1) Criar grupo(s);": "1) Csoport(ok) létrehozása;",
    "equipment.2) Atribuir equipamento(s) ao grupo;": "2) Berendezés(ek) hozzárendelése a csoporthoz;",
    "equipment.3) Atribuir usuário(s) ao grupo.": "3) Felhasználó(k) hozzárendelése a csoporthoz.",
    "equipment.Status software": "Szoftverállapot",
    "equipment.Status menu": "Menü állapota",
    "equipment.Pendente": "Függőben",
    "equipment.Aceito": "Elfogadva",
    "equipment.Recusado": "Elutasítva",
    "equipment.Atualizar software": "Szoftver frissítése",
    "equipment.Deseja enviar a atualização para o equipamento selecionado?": "El szeretné küldeni a frissítést a kiválasztott berendezésre?",
    "equipment.Companhia": "Vállalat",
    "equipment.Exportar menu": "Menü exportálása",
    "equipment.companhias": "vállalatok",
    "equipment.Nome da companhia": "Vállalat neve",
    "equipment.Procurar equipamento, usuário ou companhia": "Berendezés, felhasználó vagy vállalat keresése",
    "equipment.Versão da power": "Power verzió",
    "equipment.AINDA NÃO HÁ DADOS DE RECEITAS AQUI :(": "ITT MÉG NINCSENEK RECEPTADATOK :(",
    "equipment.AINDA NÃO HÁ DADOS DE LIMPEZAS AQUI :(": "ITT MÉG NINCSENEK TISZTÍTÁSI ADATOK :(",
    "equipment.AINDA NÃO HÁ DADOS DE EVENTOS AQUI :(": "ITT MÉG NINCSENEK ESEMÉNYADATOK :(",
    "ID": "ID",
    "equipment.Hora": "Idő",
    "equipment.EVENTOS MAIS OCORRIDOS NO EQUIPAMENTO DURANTE O PERÍODO": "A LEGGYAKRABBAN ELŐFORDULÓ ESEMÉNYEK A BERENDEZÉSEN AZ IDŐSZAK SORÁN",
    "equipment.hour": "ó",
    "equipment.minutes": "perc",
    "equipment.date format": "NN/HH/ÉÉÉÉ",
    "equipment.preparada": "végrehajtva",
    "equipment.vezes": "alkalommal",
    "equipment.vez": "alkalommal",
    "equipment.Ver": "Megtekintés",
    "equipment.Os dados são mantidos pela plataforma pelo tempo necessário para suporte, manutenção e evolução dos produtos.": "Az adatokat a platform a támogatáshoz, a karbantartáshoz és a termékek folyamatos fejlesztéséhez szükséges ideig őrzi meg.",
    "equipment.Ligado": "Bekapcsolva",
    "equipment.Desligado": "Kikapcsolva",
    "equipment.CAN ERROR": "CAN hiba",
    "equipment.CAMERA SENSOR ERROR": "Kamraszenzor hiba",
    "equipment.STEAM/RI SENSOR ERROR": "RI érzékelő hiba",
    "equipment.PROBE 1 ERROR": "1. szonda figyelmeztetés",
    "equipment.PROBE 2 ERROR": "2. szonda figyelmeztetés",
    "equipment.PROBE 3 ERROR": "3. szonda figyelmeztetés",
    "equipment.PROBE 4 ERROR": "4. szonda figyelmeztetés",
    "equipment.PROBE 5 ERROR": "5. szonda figyelmeztetés",
    "equipment.PROBE 6 ERROR": "6. szonda figyelmeztetés",
    "equipment.GENERAL PROBE ERROR": "Általános szondahiba",
    "equipment.WATER LACK ERROR": "Vízhiány figyelmeztetés",
    "equipment.HIGH PANEL TEMPERATURE ERROR": "Magas panelhőmérséklet figyelmeztetés",
    "equipment.FREQUENCY INVERTER GENERAL ERROR": "Általános frekvenciaváltó hiba",
    "equipment.FREQUENCY INVERTER COMMUNICATION ERROR": "Frekvenciaváltó kommunikációs figyelmeztetés",
    "equipment.FREQUENCY INVERTER STATUS ERROR": "Frekvenciaváltó állapotfigyelmeztetés",
    "equipment.CLEANING NOT COMPLETED ERROR": "Befejezetlen tisztítás figyelmeztetés",
    "equipment.MAGNETRON ERROR": "Magnetron figyelmeztetés",
    "equipment.EQUIPMENT FAMILY/MODEL ERROR": "Berendezés család/modell hiba",
    "equipment.BOARD TEMPERATURE SENSOR ERROR": "Panelhőmérséklet-érzékelő figyelmeztetés",
    "equipment.ENERGY MODULE ERROR": "Energia modul hiba",
    "equipment.POWER BOARD I2C BUS ERROR": "Power panel I2C busz hiba",
    "equipment.GAS SYSTEM ERROR": "Gázrendszer hiba",
    "equipment.VERY HIGH PANEL TEMPERATURE ERROR": "Rendkívül magas panelhőmérséklet hiba",
    "equipment.POWER ON": "Bekapcsolva",
    "equipment.POWER OFF": "Kikapcsolva",
    "equipment.DOOR OPENED": "Ajtó nyitva",
    "equipment.DOOR CLOSED": "Ajtó zárva",
    "equipment.CLEANING CANCELED ERROR": "A tisztítást a felhasználó megszakította",
    "equipment.PIN não encontrado. Por favor, verifique e tente novamente": "PIN nem található. Kérjük, ellenőrizze és próbálja újra",
    "equipment.Ultracongeladores": "Sokkoló hűtők",
    "equipment.PIN já vinculado a outra conta": "A PIN-kód már egy másik fiókhoz van kapcsolva",
    "equipment.Equipamento já cadastrado nesta conta": "A berendezés már regisztrálva van ehhez a fiókhoz",
    "equipment.Não foi possível validar o PIN. Tente novamente": "A PIN-kódot nem sikerült ellenőrizni. Próbálja újra",
    "equipment.Modelo definido pelo equipamento": "A berendezés által meghatározva",
    "equipment.Número de série offline inválido": "Adjon meg hét számjegyet szóköz és kezdő nulla nélkül",
    "equipment.Número de série já cadastrado": "A sorozatszám már regisztrálva van",
    "equipment.Online": "Bekapcsolva",
    "equipment.Offline": "Kikapcsolva",
    "equipment.Exibir apenas eventos": "Csak események megjelenítése",
    "equipment.Endereço": "Cím",
    "equipment.EQUIPMENT CONNECTED TO THE PLATFORM": "A berendezés csatlakozott a platformhoz",
    "equipment.EQUIPMENT DISCONNECTED FROM THE PLATFORM": "A berendezés lecsatlakozott a platformról",
    "equipment.MENU RECEIVED FROM THE PLATFORM": "A platformról érkező menüt a felhasználó elfogadta",
    "equipment.MENU REJECTED BY THE USER": "A platformról érkező menüt a felhasználó elutasította",
    "equipment.CONNECTED TO THE INTERNET": "Csatlakozva az internethez",
    "equipment.DISCONNECTED FROM THE INTERNET": "Leválasztva az internetről",
    "equipment.Infelizmente, não há versões compatíveis com este equipamento que realizem o envio de dados.": "Sajnos nincs olyan kompatibilis verzió ehhez a berendezéshez, amely támogatná az adatok küldését.",
    "equipment.O equipamento": "A berendezést",
    "equipment.deve ser atualizado para a versão mais recente de software para que passe a enviar os dados para a plataforma": "frissíteni kell a legújabb szoftververzióra, hogy adatokat küldhessen a platformra",
    "equipment.Versão do seu equipamento": "A berendezés verziója",
    "equipment.Versão disponível": "Elérhető verzió",
    "equipment.Selecione abaixo como deseja enviar a atualização para seu equipamento": "Válassza ki, hogyan szeretné elküldeni a frissítést a berendezésére",
    "equipment.Salvar no dispositivo": "Mentés az eszközre",
    "equipment.Enviar pela internet": "Küldés interneten keresztül",
    "equipment.Cliente": "Ügyfél",
    "equipment.NÚMERO DE SÉRIE NÃO ENCONTRADO": "SOROZATSZÁM NEM TALÁLHATÓ",
    "equipment.BUSCAR": "KERESÉS",
    "equipment.ACESSADOS RECENTEMENTE": "LEGUTÓBB ELÉRT",
    "equipment.SEM BUSCAS RECENTES": "NINCSENEK FRISS KERESÉSEK",
    "equipment.description.SEM BUSCAS RECENTES": "Használja a sorozatszámot a berendezések kereséséhez.",
    "equipment.Procurar equipamento pelo número de série": "Berendezés keresése sorozatszám alapján",
    "equipment.AIR FILTER CLEANING COMPLETED": "A légszűrő tisztítása befejeződött",
    "equipment.AIR FILTER CLEANING REJECTED": "A légszűrő tisztítását elutasították",
    "equipment.CATALYTIC FILTER CLEANING COMPLETED": "A katalitikus szűrő tisztítása befejeződött",
    "equipment.CATALYTIC FILTER CLEANING REJECTED": "A katalitikus szűrő tisztítását elutasították",
    "equipment.Endereço (rua, avenida, rodovia)": "Cím (utca, sugárút, út)",
    "equipment.Nº/Km": "Szám/Km",
    "equipment.ID do equipamento": "Berendezés azonosítója",
    "equipment.Todo equipamento deve ser vinculado a um grupo. Selecione um grupo da lista ou cadastre um novo clicando em + Cadastrar grupo.": "Minden berendezést egy csoporthoz kell rendelni. Válasszon egy csoportot a listából, vagy hozzon létre újat a + Csoport létrehozása gombra kattintva.",
    "equipment.Nomeie seu forno": "Nevezze el a sütőjét",
    "equipment.Para visualizar o PIN, acesse nas configurações do equipamento a Plataforma Virtual IOK.": "A PIN megtekintéséhez nyissa meg a berendezés beállításaiban az IOK Virtuális Platformot.",
    "equipment.Vinculação IOK": "IOK kapcsolódás",
   "equipment.Preparações": "Végrehajtások",
    "equipment.recipeTable.recipe": "Recept",
    "equipment.recipeTable.origin": "For.",
    "equipment.recipeTable.executions": "Végr.",
    "equipment.recipeTable.lastExecution": "Utolsó végrehajtás",
    "equipment.Última preparação": "Utolsó végrehajtás",
    "equipment.localização": "helyszínek",
    "equipment.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "MÉG NINCS REGISZTRÁLT HELYSZÍN :(",
    "equipment.description.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "Kattintson a jobb felső sarokban található gombra, és adjon hozzá helyszíneket.",
    "equipment.Procurar empresa ou local": "Vállalat vagy helyszín keresése",
    "equipment.Adicionar localização": "Helyszín hozzáadása",
    "equipment.Adicionar": "Hozzáadás",
    "equipment.espaço": "terület",
    "equipment.local": "helyszín",
    "equipment.EXCLUIR LOCALIZAÇÃO": "HELYSZÍN TÖRLÉSE",
    "equipment.Você deseja excluir esta localização?": "Biztosan törölni szeretné ezt a helyszínt?",
    "equipment.Ao fazer isso, os equipamentos atrelados à ela não exibirão nenhuma localização, sendo necessário informar um novo local para eles.": "Ezzel a hozzá kapcsolt berendezések helyszín nélkül maradnak, és új helyszínt kell megadni számukra.",
    "equipment.Localização deletada com sucesso!": "A helyszín sikeresen törölve!",
    "equipment.Erro ao deletar a localização. Tente novamente mais tarde": "Hiba történt a helyszín törlésekor. Próbálja újra később",
    "equipment.Não foi possivel deletar a localização": "A helyszín törlése nem sikerült",
    "equipment.Localização adicionada com sucesso!": "A helyszín sikeresen hozzáadva!",
    "equipment.Não foi possível adicionar a localização. Tente novamente mais tarde": "A helyszín hozzáadása nem sikerült. Próbálja újra később",
    "equipment.Nome do espaço": "Terület neve",
    "equipment.Informe o nome do espaço": "Adja meg a terület nevét",
    "equipment.Preencha o nome do espaço": "Töltse ki a terület nevét",
    "equipment.país": "Ország",
    "equipment.informe o país": "Adja meg az országot",
    "equipment.preencha o país": "Töltse ki az országot",
    "equipment.Localização editada com sucesso!": "A helyszín sikeresen módosítva!",
    "equipment.Não foi possível editar a localização. Tente novamente mais tarde": "A helyszín módosítása nem sikerült. Próbálja újra később",
    "equipment.Editar localização": "Helyszín szerkesztése",
    "equipment.Pico de preparações": "Végrehajtási csúcsidő",
    "equipment.informações da semana": "heti információk",
    "equipment.horários de pico": "csúcsidőszakok",
    "equipment.horário de pico": "csúcsidő",
    "equipment.preparações do dia": "napi végrehajtások",
    "equipment.Horário": "Időpont",
    "equipment.dia selecionado": "kiválasztott nap",
    "equipment.A limpeza adequada e diária do forno auxilia em seu funcionamento correto e impacta na garantia.": "A sütő megfelelő napi tisztítása hozzájárul a helyes működéshez, és hatással van a garanciára.",
    "equipment.Total de limpezas realizadas:": "Elvégzett tisztítások száma:",
    "equipment.Limpezas não concluídas:": "Befejezetlen tisztítások:",
    "equipment.Desde a vinculação do forno a IOK": "A sütő IOK-hoz való kapcsolása óta",
    "equipment.Equipamento ligado há:": "A berendezés bekapcsolva ennyi ideje:",
    "equipment.Total de receitas preparadas:": "Összes végrehajtott recept:",
    "equipment.Receitas preparadas": "Végrehajtott receptek",
    "equipment.Aberturas de porta": "Ajtónyitások",
    "equipment.Desde a última vez que o forno foi ligado": "A sütő utolsó bekapcsolása óta",
    "equipment.Preparação": "Végrehajtás",
    "equipment.Nenhuma localização criada": "Nincs létrehozott helyszín",
    "equipment.Acesso remoto": "Távoli hozzáférés",
    "equipment.Informe o ID da empresa que poderá acessar remotamente seu forno. Use ; para separar IDs.": "Adja meg annak a vállalatnak az azonosítóját, amely távolról hozzáférhet a sütőhöz. Több azonosítót pontosvesszővel (;) válasszon el.",
    "equipment.O acesso remoto permite que as empresas selecionadas enviem menus e atualizações para seu equipamento.": "A távoli hozzáférés lehetővé teszi a kiválasztott vállalatok számára, hogy menüket és frissítéseket küldjenek a berendezésére.",
    "equipment.Concedo acesso remoto à Prática oficial.": "Távoli hozzáférést biztosítok a hivatalos Prática számára.",
    "equipment.Deseja selecionar outros equipamentos vinculados à sua conta para conceder acesso remoto a eles?": "Szeretne más, a fiókjához kapcsolt berendezéseket is kiválasztani távoli hozzáférés biztosításához?",
    "equipment.Selecione abaixo os equipamentos para os quais deseja conceder acesso remoto à": "Válassza ki azokat a berendezéseket, amelyekhez távoli hozzáférést szeretne biztosítani:",
    "equipment.Acesso remoto concedido com sucesso!": "A távoli hozzáférés sikeresen megadva!",
    "equipment.Selecione pelo menos um equipamento": "Válasszon legalább egy berendezést",
    "equipment.Não foi possível editar os equipamentos. Tente novamente mais tarde": "A berendezések szerkesztése nem sikerült. Próbálja újra később",
    "equipment.Solicitar atendimento": "Szerviz igénylése",
    "equipment.Relate um problema": "Hiba bejelentése",
    "equipment.Descreva aqui o problema de seu equipamento": "Írja le itt a berendezés problémáját",
    "equipment.Não foi possível enviar sua solicitação de atendimento. Tente mais tarde": "A szervizigény elküldése nem sikerült. Próbálja újra később",
    "equipment.Solicitação técnica enviada com sucesso!": "A műszaki kérelem sikeresen elküldve!",
    "equipment.Enviar": "Küldés",
    "equipment.Solicitação de atendimento": "Szervizigény",
    "equipment.Informe o problema de seu equipamento": "Adja meg a berendezés problémáját",
    "equipment.Informações do magnetron": "Magnetron információk",
    "equipment.Vida útil aproximada": "Becsült élettartam",
    "equipment.MAGNETRON USAGE HOURS": "Magnetron használati órák",
    "equipment.Atendimento": "Szerviz",
    "equipment.Eventos mais ocorridos no equipamento durante o período": "A leggyakrabban előforduló események a berendezésen az időszak során",
    "equipment.EQUIPAMENTO SEM NÚMERO DE SÉRIE": "BERENDEZÉS SOROZATSZÁM NÉLKÜL",
    "equipment.Filtros": "Szűrők",
    "equipment.Filtrar": "Szűrés",
    "equipment.Limpar filtros": "Szűrők törlése",
    "equipment.Procurar por modelo, versão ou país": "Keresés modell, verzió vagy ország szerint",
    "equipment.Procurar equipamento, NS, modelo, versão ou país": "Keresés berendezés, sorozatszám, modell, verzió vagy ország szerint",
    "equipment.Os seguintes IDs não pertencem a uma companhia do tipo 'Distribuidor' e foram removidos": "A következő azonosítók nem tartoznak 'Forgalmazó' típusú vállalathoz, ezért eltávolításra kerültek",
    "equipment.BAIXAR VERSÕES": "VERZIÓK LETÖLTÉSE",
    "equipment.Compatível com todas as versões da IHM.": "Kompatibilis az IHM összes verziójával.",
    "equipment.Compatível apenas com a versão 2.0.0C da Power.": "Csak a Power 2.0.0C verziójával kompatibilis.",
    "equipment.Procurar evento": "Esemény keresése",
    "equipment.Forno conectado": "Csatlakoztatott sütő",
    "equipment.Limpeza de filtro de ar": "Légszűrő tisztítása",
    "equipment.Limpeza de filtro catalítico": "Katalitikus szűrő tisztítása",
    "equipment.Limpeza realizada": "Elvégzett tisztítás",
    "equipment.Limpeza recomendada": "Ajánlott tisztítás",
    "equipment.Forno ligado": "Sütő bekapcsolva",
    "equipment.Inversor de frequência": "Frekvenciaváltó",
    "equipment.Temperatura de painel": "Panel hőmérséklete",
    "equipment.Sensor da câmara": "Kamraszenzor",
    "equipment.Magnetron": "Magnetron",
    "equipment.Power": "Power",
    "equipment.Informações de menu": "Menüinformációk",
    "equipment.Limpeza": "Tisztítás",
    "equipment.O equipamento já está utilizando a versão mais recente do software.": "A berendezés már a legfrissebb szoftververziót használja.",
    "equipment.Atenção: o cálculo da vida útil do magnetron não considera o tempo de uso anterior à versão F1.1.0.": "Figyelem: a magnetron élettartamának számítása nem veszi figyelembe az F1.1.0 verzió előtti használati időt.",
    "equipment.Equipamentos com erro": "Hibás berendezések",
    "equipment.Em breve você terá acesso a dados importantes enviados pelo forno, como horário de pico, receitas mais executadas, histórico de higienizações, eventos ocorridos e mais! Lembre-se de manter seu equipamento sempre atualizado com as novas versões disponíveis na plataforma.": "Hamarosan hozzáférhet a sütő által küldött fontos adatokhoz, például a csúcsidőszakokhoz, a leggyakrabban végrehajtott receptekhez, a tisztítási előzményekhez, az eseményekhez és még sok máshoz! Ne feledje, hogy berendezését mindig frissítse a platformon elérhető legújabb verziókra.",
    "equipment.Para que a execução da limpeza seja registrada no equipamento e enviada à plataforma, é necessário seguir o passo a passo completo do procedimento no forno. Não é obrigatório assistir aos vídeos dos passos, quando disponíveis.": "Ahhoz, hogy a tisztítás végrehajtása rögzítésre kerüljön a berendezésen és elküldésre kerüljön a platformra, a sütőben a teljes folyamatot végig kell követni. A lépésekhez tartozó videók megtekintése nem kötelező, ha rendelkezésre állnak.",
    "equipment.Horas de uso": "Használati órák",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.0.6": "A magnetron használati óráinak számlálása az F1.0.6 verziótól kezdődik",
    "equipment.A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.": "A szoftverfrissítés körülbelül 15 percet vesz igénybe. A folyamat során a sütő újraindul, és a befejezésig kék képernyőt jelenít meg. A hibák elkerülése érdekében tartsa bekapcsolva és internethez csatlakoztatva. Ha USB-meghajtóval frissít, ne távolítsa el a folyamat végéig.",
    'equipment.Equipamento {name} com software {version} devem ser atualizador via USB. A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.': "A(z) {name} készülék {version} szoftverrel USB-n keresztül frissítendő. A szoftverfrissítés körülbelül 15 percet vesz igénybe. A folyamat során a sütő újraindul, és a befejezésig kék képernyőt jelenít meg. A hibák elkerülése érdekében tartsa bekapcsolva és internethez csatlakoztatva. Ha USB-meghajtóval frissít, ne távolítsa el a folyamat végéig.",
    "equipment.Observação": "Megjegyzés:",
    "equipment.Para versões ST2.0.0 e superiores, o envio de atualização pela plataforma (Wi-fi) seguirá disponibilizado normalmente.": "Az ST2.0.0 és újabb verziók esetében a frissítés platformon keresztüli (Wi-Fi) kiküldése továbbra is elérhető lesz.",
    "equipment.Aqui você encontra informações gerais sobre o equipamento;": "Itt általános információkat talál a berendezésről;",
    "equipment.Ao clicar nestes botões você consegue solicitar atendimento para seu forno e exportar seus dados em planilhas do Excel;": "Ezekre a gombokra kattintva szervizt kérhet a sütőhöz, valamint Excel-táblázatokba exportálhatja az adatokat;",
    "equipment.Nos quadros abaixo você encontra informações detalhadas sobre execuções de receitas;": "Az alábbi panelek részletes információkat tartalmaznak a receptvégrehajtásokról;",
    "equipment.Horário de pico;": "Csúcsidőszak;",
    "equipment.Informações referentes a higienização;": "Tisztítással kapcsolatos információk;",
    "equipment.E histórico de eventos;": "Valamint az eseményelőzmények;",
    "equipment.Lembre-se de que é necessário selecionar o período do qual deseja visualizar os dados. É possível fazer isso ao clicar sobre o calendário dos quadros e ao selecionar filtros.": "Ne feledje, hogy ki kell választania azt az időszakot, amelynek adatait meg szeretné tekinteni. Ezt a panelek naptárára kattintva vagy szűrők kiválasztásával teheti meg.",
    "equipment.Baixando o arquivo... Ele estará disponível em breve!": "A fájl letöltése folyamatban... Hamarosan elérhető lesz!",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.1.0": "A magnetron használati óráinak számlálása az F1.1.0 verziótól kezdődik",
    "equipment.Data de fabricação": "Gyártási dátum",
    "equipment.manutenção": "karbantartás",
    "equipment.Ao buscar e localizar um número de série, será aberto um canal temporário diretamente com o forno, permitindo o compartilhamento de seus dados de manutenção. Esses dados não serão armazenados na plataforma, sendo necessário realizar uma nova busca sempre que desejado.": "Egy sorozatszám keresése és megtalálása után ideiglenes kapcsolat jön létre közvetlenül a sütővel, lehetővé téve a karbantartási adatok megosztását. Ezek az adatok nem kerülnek tárolásra a platformon, ezért minden alkalommal új keresést kell indítani.",
    "equipment.INFORME UM NÚMERO DE SÉRIE E CLIQUE EM BUSCAR": "ADJON MEG EGY SOROZATSZÁMOT ÉS KATTINTSON A KERESÉS GOMBRA",
    "equipment.Apenas os modelos FIT Express / FIT Single Mag / FIT XL com a versão de software F2.1.0 enviarão dados de manutenção. As informações, principalmente as dos contadores, serão contabilizadas a partir dessa versão.": "Csak a FIT Express / FIT Single Mag / FIT XL modellek küldenek karbantartási adatokat az F2.1.0 szoftververziótól kezdve. Az információk, különösen a számlálók adatai, ettől a verziótól kerülnek rögzítésre.",
    "equipment.Procurar número de série": "Sorozatszám keresése",
    "equipment.ENCERRAR SESSÃO": "MUNKAMENET BEFEJEZÉSE",
    "equipment.Alerta": "Figyelmeztetés",
    "equipment.Local": "Helyszín",
    "equipment.Software": "Szoftver",
    "equipment.Forno sem limpeza há": "A sütő ennyi ideje nem volt tisztítva:",
    "equipment.Horário de pico": "Csúcsidőszak",
    "equipment.HP": "HP",
    "equipment.RECIPE STARTED": "Recept elindítva",
    "equipment.RECIPE CANCELED": "A receptet a felhasználó megszakította",
    "equipment.RECIPE COMPLETED": "Recept sikeresen befejezve",
    "equipment.DOOR OPENED RECIPE": "Ajtó kinyitva a recept végrehajtása közben",
    "equipment.DOOR CLOSED RECIPE": "Ajtó bezárva a recept végrehajtása közben",
    "equipment.Receitas iniciadas": "Elindított receptek",
    "equipment.Receitas concluídas": "Befejezett receptek",
    "equipment.Receitas interrompidas": "Megszakított receptek",
    "equipment.Total de receitas concluídas:": "Befejezett receptek összesen:",
    "equipment.TOTAL DE RECEITAS INTERROMPIDAS": "MEGSZAKÍTOTT RECEPTEK ÖSSZESEN",
    "equipment.DOWNLOAD_PROGRESS": "FÁJL LETÖLTÉSE... KÉRJÜK VÁRJON, FOLYAMAT: {progress}%",
    "equipment.Informe o número de série do forno": "Adja meg a sütő sorozatszámát",
    "equipment.preencha o número de série do forno": "Töltse ki a sütő sorozatszámát",
    "equipment.NÚMERO DE SÉRIE NÃO CADASTRADO": "A SOROZATSZÁM NINCS REGISZTRÁLVA",
    "equipment.Número de série não encontrado. Por favor, verifique e tente novamente": "A sorozatszám nem található. Kérjük, ellenőrizze és próbálja újra.",
    "equipment.Antes de iniciar a atualização, faça o backup das receitas salvas no equipamento para garantir a integridade dos dados. O backup pode ser feito via pen drive ou pela plataforma. Isso permite a recuperação das informações em caso de perda.": "A frissítés megkezdése előtt készítsen biztonsági másolatot a berendezésen mentett receptekről az adatok sértetlenségének biztosítása érdekében. A biztonsági mentés USB-meghajtóval vagy a platformon keresztül is elvégezhető. Ez lehetővé teszi az adatok helyreállítását adatvesztés esetén.",
    "equipment.MENU RECEIVED FROM THE PLATFORM BY FORCED METHOD": "Menü fogadva a platformról kényszerített frissítéssel",
    "equipment.Nome da receita não encontrado": "A recept neve nem található",
    "equipment.passos": "{count, plural, one {lépés} other {lépések}}",
    "equipment.minAbbreviation": "perc",
    "equipment.secAbbreviation": "mp",
    "equipment.Configurações": "Beállítások",
    "equipment.Tempo de preaquecimento": "Előmelegítési idő",
    "equipment.Formato de data": "Dátumformátum",
    "equipment.Formato de hora": "Időformátum",
    "equipment.Unidade de temperatura": "Hőmérséklet mértékegysége",
    "equipment.Aquecer/dourar mais": "További melegítés/pirítás",
    "equipment.Fabricante": "Gyártó",
    "equipment.Voltagem": "Feszültség",
    "equipment.Introdução": "Bevezetés",
    "equipment.Modelo": "Modell",
    "equipment.Motor": "Motor",
    "equipment.Hostname": "Hosztnév",
    "equipment.STATUS DA OPERAÇÃO": "MŰVELETI ÁLLAPOT",
    "equipment.ÚLTIMA LIMPEZA": "UTOLSÓ TISZTÍTÁS",
    "equipment.VELOCIDADE DO MOTOR": "MOTOR SEBESSÉGE",
    "equipment.TENSÃO ATUAL": "AKTUÁLIS FESZÜLTSÉG",
    "equipment.Sensores e periféricos": "Szenzorok és perifériák",
    "equipment.Contadores": "Számlálók",
    "equipment.HORAS DE USO DO MOTOR": "MOTOR ÜZEMÓRÁI",
    "equipment.HORAS DE USO DO MAGNETRON": "MAGNETRON ÜZEMÓRÁI",
    "equipment.ABERTURAS DE PORTA": "AJTÓNYITÁSOK",
    "equipment.ATUAÇÃO DO RELE DA POWER": "POWER RELÉ MŰKÖDÉSE",
    "equipment.ATUAÇÃO DO SENSOR DE PORTA": "AJTÓÉRZÉKELŐ MŰKÖDÉSE",
    "equipment.RECEITAS EXECUTADAS": "VÉGREHAJTOTT RECEPTEK",
    "equipment.LIMPEZAS EXECUTADAS": "ELVÉGZETT TISZTÍTÁSOK",
    "equipment.HORAS DE USO DO FILTRO CATALÍTICO": "KATALITIKUS SZŰRŐ ÜZEMÓRÁI",
    "equipment.HORAS DE USO DO FILTRO DE AR": "LÉGSZŰRŐ ÜZEMÓRÁI",
    "equipment.CORRENTE DO MAGNETRON": "MAGNETRON ÁRAMERŐSSÉGE",
    "equipment.Erros": "Hibák",
    "equipment.status online": "online állapot",
    "equipment.status offline": "offline állapot",
    "equipment.software accepted": "szoftver elfogadva",
    "equipment.menu accepted": "menü elfogadva",
    "equipment.software pending": "szoftver függőben",
    "equipment.menu pending": "menü függőben",
    "equipment.software refused": "szoftver elutasítva",
    "equipment.menu refused": "menü elutasítva",
    "equipment.Ativado": "Aktiválva",
    "equipment.Desativado": "Deaktiválva",
    "equipment.Cozinhando": "Főzés folyamatban",
    "equipment.Pré-aquecendo": "Előmelegítés folyamatban",
    "equipment.Em espera": "Készenléti állapot",
    "equipment.Limpando": "Tisztítás folyamatban",
    "equipment.horas": "óra",
    "equipment.Erro CAN": "CAN hiba",
    "equipment.Erro no sensor de câmara": "Kamraérzékelő hiba",
    "equipment.Alerta de temperatura alta no painel": "Magas panelhőmérséklet figyelmeztetés",
    "equipment.Erro de temperatura alta no painel": "Magas panelhőmérséklet hiba",
    "equipment.Alerta de comunicação no inversor de frequência": "Frekvenciaváltó kommunikációs figyelmeztetés",
    "equipment.Alerta de status no inversor de frequência": "Frekvenciaváltó állapotfigyelmeztetés",
    "equipment.Alerta na corrente do magnetron": "Magnetron áramfigyelmeztetés",
    "equipment.Erro no modelo do equipamento": "Berendezésmodell hiba",
    "equipment.Erro no módulo de energia": "Energiamodul hiba",
    "equipment.Erro I2C": "I2C hiba",
    "equipment.Erro de temperatura alta na placa": "Magas panelhőmérséklet hiba",
    "equipment.Fechado": "Zárva",
    "equipment.Aberto": "Nyitva",
    "equipment.Câmara": "Kamra",
    "equipment.Placa": "Panel",
    "equipment.Tensão": "Feszültség",
    "equipment.Corrente da placa": "Panel áramerőssége",
    "equipment.Velocidade do motor": "Motor fordulatszáma",
    "equipment.Rele da resistência": "Fűtőelem relé",
    "equipment.Rele de curto circuito": "Rövidzárlati relé",
    "equipment.Ventilador radial": "Radiális ventilátor",
    "equipment.Led vermelho": "Piros LED",
    "equipment.Led verde": "Zöld LED",
    "equipment.Led azul": "Kék LED",
    "equipment.Erro": "Hiba",
    "equipment.Sensor": "Érzékelő",
    "equipment.Valor": "Érték",
    "equipment.Manutenção da temperatura": "Hőmérséklet fenntartása",
    "equipment.Manutenção": "Fenntartás",
    "equipment.Esfriando": "Hűtés folyamatban",
    "equipment.CEILING SENSOR ERROR": "Tetőérzékelő hiba",
    "equipment.BALLAST SENSOR ERROR": "Fenékkő (lastro) érzékelő hiba",
    "equipment.VAPORIZER SENSOR ERROR": "Párologtató érzékelő hiba",
    "equipment.EQUIPMENT CONSUMPTION": "Fogyasztás",
    "equipment.Sensores": "Érzékelők",
    "equipment.Falta de água": "Vízhiány",
    "equipment.Executando Receita": "Recept végrehajtása",
    "equipment.Executando Limpeza": "Tisztítás végrehajtása",
    "equipment.Dia": "Nap",
    "equipment.Semana": "Hét",
    "equipment.Mês": "Hónap",
    "equipment.Tempo": "Idő",
    "equipment.Segunda": "Hétfő",
    "equipment.Terça": "Kedd",
    "equipment.Quarta": "Szerda",
    "equipment.Quinta": "Csütörtök",
    "equipment.Sexta": "Péntek",
    "equipment.Sábado": "Szombat",
    "equipment.Domingo": "Vasárnap",
    "equipment.CONSUMO ESTIMADO": "BECSÜLT FOGYASZTÁS",
    "equipment.CONSUMO ATUAL": "AKTUÁLIS FOGYASZTÁS",
    "equipment.ECONOMIA COM MODO ECO": "MEGTAKARÍTÁS ECO MÓDBAN",
    "equipment.MÉDIA SEMANAL": "HETI ÁTLAG",
    "equipment.MÉDIA MENSAL": "HAVI ÁTLAG",
    "equipment.Consumo de energia": "Energiafogyasztás",
    "equipment.CONSUMO ACUMULADO": "HALMOZOTT FOGYASZTÁS",
    "equipment.MÉDIA DIÁRIA": "NAPI ÁTLAG",
    "equipment.mês selecionado": "kiválasztott hónap",
    "equipment.Este valor representa a soma total dos consumos de cada hora do dia.": "Ez az érték az adott nap minden órájának fogyasztásösszegét mutatja.",
    "equipment.Este valor representa a soma total dos consumos de cada dia.": "Ez az érték az egyes napok teljes fogyasztásának összegét mutatja.",
    "equipment.Este valor representa a soma total dos consumos de cada semana.": "Ez az érték az egyes hetek teljes fogyasztásának összegét mutatja.",
    "equipment.Este valor representa a soma total dos consumos de cada mês.": "Ez az érték az egyes hónapok teljes fogyasztásának összegét mutatja.",
    "equipment.Este valor representa a média do consumo das horas, apresentando assim uma estimativa baseada em seu uso.": "Ez az érték az óránkénti átlagos fogyasztást mutatja, így egy használaton alapuló becslést ad.",
    "equipment.Este valor representa a média do consumo de cada dia, apresentando assim uma estimativa baseada em seu uso.": "Ez az érték a napi átlagos fogyasztást mutatja, így egy használaton alapuló becslést ad.",
    "equipment.Este valor representa a média do consumo semanal, apresentando assim uma estimativa baseada em seu uso.": "Ez az érték a heti átlagos fogyasztást mutatja, így egy használaton alapuló becslést ad.",
    "equipment.Este valor representa a média do consumo dos últimos dois meses, apresentando assim uma estimativa baseada em seu uso.": "Ez az érték az elmúlt két hónap átlagos fogyasztását mutatja, így egy használaton alapuló becslést ad.",
    "equipment.Este valor representa a soma total da economia de consumo de cada hora do dia com a utilização do modo Eco.": "Ez az érték az Eco mód használatával elért óránkénti fogyasztásmegtakarítás teljes összegét mutatja.",
    "equipment.Este valor representa a soma total da economia de consumo de cada dia com a utilização do modo Eco.": "Ez az érték az Eco mód használatával elért napi fogyasztásmegtakarítás teljes összegét mutatja.",
    "equipment.Este valor representa a soma total da economia de consumo semanal com a utilização do modo Eco.": "Ez az érték az Eco mód használatával elért heti fogyasztásmegtakarítás teljes összegét mutatja.",
    "equipment.Este valor representa a soma total da economia de consumo mensal com a utilização do modo Eco.": "Ez az érték az Eco mód használatával elért havi fogyasztásmegtakarítás teljes összegét mutatja.",
    "equipment.Este valor representa a média de consumo dos últimos 7 dias, desconsiderando o dia atual.": "Ez az érték az elmúlt 7 nap átlagos fogyasztását mutatja, a mai nap figyelmen kívül hagyásával.",
    "equipment.Este valor representa a média de consumo das últimas 4 semanas.": "Ez az érték az elmúlt 4 hét átlagos fogyasztását mutatja.",
    "equipment.Este valor representa a média de consumo dos últimos 2 meses, desconsiderando o mês atual.": "Ez az érték az elmúlt 2 hónap átlagos fogyasztását mutatja, az aktuális hónap figyelmen kívül hagyásával.",
    "equipment.Lista de consumo de energia": "Energiafogyasztási lista",
    "equipment.Período": "Időszak",
    "equipment.Consumo (kWh)": "Fogyasztás (kWh)",
    "equipment.Economia com ECO (kWh)": "Megtakarítás ECO móddal (kWh)",
    "equipment.Total": "Összesen",
    "equipment.Sensor de RI": "RI érzékelő",
    "equipment.HUMIDITY SENSOR ERROR": "Páratartalom-érzékelő hiba",
    "equipment.TEMPERATURE SENSOR ERROR": "Hőmérséklet-érzékelő hiba",
    "equipment.WATER FILTER CLEANING COMPLETED": "Vízszűrő csere befejezve",
    "equipment.WATER FILTER CLEANING REJECTED": "Vízszűrő csere elutasítva",
    "equipment.HOOD TURNED ON": "Páraelszívó bekapcsolva",
    "equipment.HOOD TURNED OFF": "Páraelszívó kikapcsolva",
    "equipment.AUTOMATIC PREHEATING REJECTED": "Automatikus előmelegítés elutasítva",
    "equipment.Receitas Forno": "Sütő receptek",
    "equipment.Receitas Fermentadora": "Kelesztő receptek",
    "equipment.média diária": "napi átlag",
    "equipment.média de execução diária": "napi végrehajtási átlag",
    "equipment.FERMENTADORA": "KELESZTŐ",
    "equipment.FORNO": "SÜTŐ",
    "equipment.DIA": "NAP",
    "equipment.Baixado": "Letöltve",
    "equipment.A limpeza diária do equipamento auxilia em seu bom funcionamento e impacta na garantia.": "A berendezés napi tisztítása hozzájárul a megfelelő működéshez és hatással van a garanciára.",
    "equipment.Desde a vinculação do equipamento ao IOK": "A berendezés IOK-hoz történő csatlakoztatása óta",
    "equipment.Total desde a vinculação do equipamento ao IOK": "Összesen a berendezés IOK-hoz történő csatlakoztatása óta",
    "equipment.Receitas do forno": "Sütő receptek",
    "equipment.Receitas da fermentadora": "Kelesztő receptek",
    "equipment.FERM.": "KEL.",
    "equipment.Fermentadora": "Kelesztő",
    "equipment.Coifa": "Páraelszívó",
    "equipment.Preaquecimento automático": "Automatikus előmelegítés",
    "equipment.nivel": "szint",
    "equipment.Fermentadora ligada": "Kelesztő bekapcsolva",
    "equipment.Fermentadora desligada": "Kelesztő kikapcsolva",
    "equipment.Forno desligado": "Sütő kikapcsolva",
    "equipment.Equipamento ligado": "Berendezés bekapcsolva",
    "equipment.Equipamento desligado": "Berendezés kikapcsolva",
    "equipment.visualizar haccp": "HACCP megtekintése",
    "equipment.HACCP": "HACCP",
    "equipment.Atualizar Equip.": "Berendezés frissítése",
    "equipment.Consumo de agua por receita": "Vízfogyasztás receptenkként",
    "equipment.Consumo de energia por receita": "Energiafogyasztás receptenkként",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE AGUA POR RECEITA :(": "MÉG NINCS ADAT A RECEPTENKÉNTI VÍZFOGYASZTÁSRÓL :(",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE ENERGIA POR RECEITA :(": "MÉG NINCS ADAT A RECEPTENKÉNTI ENERGIAFOGYASZTÁSRÓL :(",
    "equipment.LITROS CONSUMIDOS NO DIA": "NAPONTA ELFOGYASZTOTT LITEREK",
    "equipment.ENERGIA CONSUMIDA NO DIA": "NAPONTA ELFOGYASZTOTT ENERGIA",
    "equipment.CONSUMO ACUMULADO SEMANAL": "HETI HALMOZOTT FOGYASZTÁS",
    "equipment.CONSUMO ACUMULADO MENSAL": "HAVI HALMOZOTT FOGYASZTÁS",
    "equipment.Receitas": "Receptek",
    "equipment.Consumo (L)": "Fogyasztás (L)",
    "equipment.Exec. dia - (L)": "Napi végreh. - (L)",
    "equipment.Exec. semana - (L)": "Heti végreh. - (L)",
    "equipment.Exec. mês - (L)": "Havi végreh. - (L)",
    "equipment.Exec. dia - (kWh)": "Napi végreh. - (kWh)",
    "equipment.Exec. semana - (kWh)": "Heti végreh. - (kWh)",
    "equipment.Exec. mês - (kWh)": "Havi végreh. - (kWh)",
    "equipment.Agua consumida (litros)": "Felhasznált víz (liter)",
    "equipment.Energia consumida (kWh)": "Felhasznált energia (kWh)",
    "equipment.temperatura da câmara": "Kamrahőmérséklet",
    "equipment.temperatura do vapor": "Gőzhőmérséklet",
    "equipment.último evento listado": "Utolsó listázott esemény",
    "equipment.temperatura da sonda": "Szondahőmérséklet",
    "equipment.porta": "Ajtó",
    "equipment.temperatura": "Hőmérséklet",
    "equipment.temperatura atual": "Aktuális hőmérséklet",
    "equipment.média de oscilação diária": "Napi átlagos ingadozás",
    "equipment.oscilação diária da temperatura": "Napi hőmérséklet-ingadozás",
    "equipment.temperature.sectionTitle": "Hőmérséklet",
    "equipment.temperature.currentChamber": "AKTUÁLIS KAMRAHŐMÉRSÉKLET:",
    "equipment.temperature.currentProbe": "AKTUÁLIS SZONDAHŐMÉRSÉKLET:",
    "equipment.temperature.currentSteam": "AKTUÁLIS GŐZHŐMÉRSÉKLET:",
    "equipment.temperature.dailyOscillation": "Napi hőmérséklet-ingadozás",
    "equipment.temperature.chamberShort": "Kamra",
    "equipment.temperature.probeShort": "Szonda",
    "equipment.temperature.axisLabel": "Hőmérséklet {unit}",
    "equipment.temperature.dailyAverage": "NAPI ÁTLAG",
    "equipment.temperature.weeklyAverage": "HETI ÁTLAG",
    "equipment.temperature.monthlyAverage": "HAVI ÁTLAG",
    "equipment.temperature.lastListedEvent": "Utolsó listázott esemény",
    "equipment.temperature.door": "Ajtó",
    "equipment.temperature.open": "NYITVA",
    "equipment.temperature.closed": "ZÁRVA",
    "equipment.temperature.defineTimeRange": "Időtartomány meghatározása:",
    "equipment.temperature.until": "-ig",
    "equipment.cleaningType.smart": "Intelligens tisztítás",
    "equipment.cleaningType.light": "Könnyű tisztítás",
    "equipment.cleaningType.medium": "Közepes tisztítás",
    "equipment.cleaningType.heavy": "Erős tisztítás",
    "equipment.cleaningType.decalcifying": "Vízkőmentesítő tisztítás",
    "equipment.cleaningType.security": "Biztonsági tisztítás",
    "equipment.cleaningType.rinse": "Öblítés",
    "equipment.cleaningType.custom": "Egyedi tisztítás",
    "equipment.cleaningTypeShort.smart": "Intelligens",
    "equipment.cleaningTypeShort.light": "Könnyű",
    "equipment.cleaningTypeShort.medium": "Közepes",
    "equipment.cleaningTypeShort.heavy": "Erős",
    "equipment.cleaningTypeShort.decalcifying": "Vízkőment.",
    "equipment.cleaningTypeShort.security": "Biztonsági",
    "equipment.cleaningTypeShort.rinse": "Öblítés",
    "equipment.cleaningTypeShort.custom": "Egyedi",
    "equipment.gerar gráficos": "grafikonok generálása",
    "equipment.Realizada": "Elvégezve",
    "equipment.Recomendada": "Ajánlott",
    "equipment.Dias da semana": "A hét napjai",
    "equipment.Horário 24h": "24 órás időformátum",
    "equipment.seg": "H",
    "equipment.ter": "K",
    "equipment.qua": "Sze",
    "equipment.qui": "Cs",
    "equipment.sex": "P",
    "equipment.sab": "Szo",
    "equipment.dom": "V",
    "equipment.Desconhecido": "Ismeretlen",
    "equipment.AINDA NÃO HÁ DADOS DE CONSUMO DE ENERGIA AQUI :(": "MÉG NINCS ENERGIAFOGYASZTÁSI ADAT ITT :(",
    "equipment.monthShort.Jan": "Jan",
    "equipment.monthShort.Fev": "Feb",
    "equipment.monthShort.Mar": "Már",
    "equipment.monthShort.Abr": "Ápr",
    "equipment.monthShort.Mai": "Máj",
    "equipment.monthShort.Jun": "Jún",
    "equipment.monthShort.Jul": "Júl",
    "equipment.monthShort.Ago": "Aug",
    "equipment.monthShort.Set": "Szept",
    "equipment.monthShort.Out": "Okt",
    "equipment.monthShort.Nov": "Nov",
    "equipment.monthShort.Dez": "Dec",
    "equipment.settingsChange.category": "Paraméter módosítása",
    "equipment.settingsChange.factoryTitle": "Műszaki paraméter módosítása",
    "equipment.settingsChange.userTitle": "Felhasználói paraméter módosítása",
    "equipment.settingsChange.changedTo": "{label} módosítva erre: {value}",
    "equipment.settingsChange.hardResetExecuted": "Hard reset végrehajtva",
    "equipment.settingsChange.userFactoryResetExecuted": "Felhasználói gyári visszaállítás végrehajtva",
    "equipment.settingsChange.magSensorEnabled": "magnetron érzékelő",
    "equipment.settingsChange.serialNumber": "sorozatszám",
    "equipment.settingsChange.manufactureDate": "gyártási dátum",
    "equipment.settingsChange.inverterType": "inverter típusa",
    "equipment.settingsChange.preHeatMotorSpeed": "előmelegítő motor sebessége",
    "equipment.settingsChange.voltage": "feszültség",
    "equipment.settingsChange.oemModeEnabled": "OEM mód",
    "equipment.settingsChange.controlDoor": "ajtóvezérlés",
    "equipment.settingsChange.hardReset": "hard reset",
    "equipment.settingsChange.preHeatTemperatureOne": "előmelegítési hőmérséklet 1",
    "equipment.settingsChange.preHeatTemperatureTwo": "előmelegítési hőmérséklet 2",
    "equipment.settingsChange.preHeatTime": "előmelegítési idő",
    "equipment.settingsChange.preHeatTwoEnabled": "előmelegítés 2",
    "equipment.settingsChange.userFactoryReset": "felhasználói gyári visszaállítás",
    "equipment.settingsChange.enableManualMode": "kézi üzemmód",
    "equipment.settingsChange.enableFavorites": "kedvencek",
    "equipment.settingsChange.enableHeatBrown": "erősebb melegítés/pirítás",
    "equipment.settingsChange.enableRepeatRecipe": "recept ismétlése",
    "equipment.settingsChange.enableOperatorMode": "kezelői mód",
    "equipment.settingsChange.enableAutoImport": "automatikus importálás",
    "equipment.settingsChange.enableRecipePreRunMessage": "üzenet a recept előkészítése előtt",
    "equipment.settingsChange.controlDoorTwoInputs": "2 bemenet",
    "equipment.settingsChange.controlDoorThreeInputs": "3 bemenet",
    
    //LOJAS
    "store.Procurar loja": "Üzlet keresése",
    "store.Excluir": "Törlés",
    "store.Editar": "Szerkesztés",
    "store.nome": "Név",
    "store.equipamentos": "Berendezések",
    "store.Equipamentos vinculados": "Kapcsolódó berendezések",
    "store.cidade": "Város",
    "store.estado": "Megye",
    "store.salvar": "mentés",
    "store.cadastrar loja": "üzlet regisztrálása",
    "store.Nome fantasia": "Kereskedelmi név",
    "store.Preencha o nome da loja": "Adja meg az üzlet nevét",
    "store.CNPJ": "CNPJ",
    "store.Preencha o CNPJ da loja": "Adja meg az üzlet CNPJ számát",
    "store.CEP": "Irányítószám",
    "store.Preencha o CEP da loja": "Adja meg az üzlet irányítószámát",
    "store.Informe o nome fantasia": "Adja meg a kereskedelmi nevet",
    "store.Cidade": "Város",
    "store.Informe a cidade": "Adja meg a várost",
    "store.Preencha a cidade": "Töltse ki a város mezőt",
    "store.UF": "Állam",
    "store.Preencha o UF da loja": "Adja meg az üzlet államát",
    "store.Bairro": "Városrész",
    "store.Informe o bairro": "Adja meg a városrészt",
    "store.Preencha o bairro da loja": "Adja meg az üzlet városrészét",
    "store.Endereço": "Cím",
    "store.Informe o endereço": "Adja meg a címet",
    "store.Preencha o endereço da loja": "Adja meg az üzlet címét",
    "store.Nº": "Sz.",
    "store.Preencha o número": "Adja meg a számot",
    "store.Loja cadastrada com sucesso": "Az üzlet sikeresen regisztrálva",
    "store.Erro ao adicionar loja. Tente novamente": "Hiba történt az üzlet hozzáadásakor. Kérjük, próbálja újra",
    "store.Loja deletada com sucesso": "Az üzlet sikeresen törölve",
    "store.Erro ao deletar loja. Tente novamente mais tarde": "Hiba történt az üzlet törlésekor. Kérjük, próbálja újra később",
    "store.AINDA NÃO HÁ NENHUMA LOJA CADASTRADA :(": "MÉG NINCS REGISZTRÁLT ÜZLET :(",
    "store.EXCLUIR LOJA": "ÜZLET TÖRLÉSE",
    "store.Você deseja excluir a loja da plataforma IOK?": "Biztosan törölni szeretné az üzletet az IOK platformról?",
    "store.Ao fazer isso, os equipamentos atrelados à ela não terão vínculo com nenhuma loja, a menos que os vincule novamente.": "Ezzel a hozzá kapcsolt berendezések elveszítik az üzlethez való kapcsolatukat, amíg újra hozzá nem rendeli őket.",
    "store.loja editada com sucesso": "Az üzlet sikeresen szerkesztve",
    "store.não foi possível editar a loja. Tente novamente mais tarde": "Az üzlet szerkesztése nem sikerült. Kérjük, próbálja újra később",
    "store.editar loja": "üzlet szerkesztése",
    "store.Procurar grupo de equipamentos": "Berendezéscsoport keresése",
    "store.cadastrar grupo": "csoport regisztrálása",
    "store.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "MÉG NINCS REGISZTRÁLT CSOPORT :(",
    "store.description.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "Kattintson a jobb felső sarokban található gombra és adjon hozzá csoportokat.",
    "store.cadastrar grupo de equipamentos": "berendezéscsoport regisztrálása",
    "store.grupo de equipamentos cadastrado com sucesso!": "A berendezéscsoport sikeresen regisztrálva!",
    "store.não foi possível cadastrar o grupo. Tente novamente mais tarde": "A csoport regisztrálása nem sikerült. Kérjük, próbálja újra később",
    "store.Nome do grupo": "Csoport neve",
    "store.informe o nome do grupo": "Adja meg a csoport nevét",
    "store.preencha o nome do grupo": "Töltse ki a csoport nevét",
    "store.Grupo de equipamentos deletado com sucesso!": "A berendezéscsoport sikeresen törölve!",
    "store.Erro ao deletar o grupo. Tente novamente mais tarde": "Hiba történt a csoport törlésekor. Kérjük, próbálja újra később",
    "store.EXCLUIR GRUPO DE EQUIPAMENTOS": "BERENDEZÉSCSOPORT TÖRLÉSE",
    "store.Você deseja excluir este grupo de equipamentos da plataforma IOK?": "Biztosan törölni szeretné ezt a berendezéscsoportot az IOK platformról?",
    "store.Ao fazer isso, os equipamentos atrelados à ele não terão vínculo com nenhum grupo, a menos que os vincule novamente.": "Ezzel a hozzá kapcsolt berendezések elveszítik a csoporthoz való kapcsolatukat, amíg újra hozzá nem rendeli őket.",
    "store.grupo de equipamentos editado com sucesso!": "A berendezéscsoport sikeresen szerkesztve!",
    "store.não foi possível editar o grupo. Tente novamente mais tarde": "A csoport szerkesztése nem sikerült. Kérjük, próbálja újra később",
    "store.editar grupo de equipamentos": "berendezéscsoport szerkesztése",
    "store.CEP não encontrado no Brasil": "Az irányítószám nem található Brazíliában",
    "store.Cadastrar": "Regisztráció",
    "store.Equipamentos vinculados": "Kapcsolódó berendezések",
    
    // NAVBAR
    "navbar.home": "Kezdőlap",
    "navbar.cookbook": "Szakácskönyv",
    "navbar.my menus": "Saját menük",
    "navbar.equipment": "Berendezések",
    "navbar.users": "Felhasználók",
    "navbar.calls": "Ügyfélszolgálat",
    "navbar.settings": "Beállítások",
    "navbar.help": "Súgó",
    "navbar.logout": "Kilépés",
    "navbar.Editar conta": "Fiók szerkesztése",
    "navbar.API Externa": "Külső API",
    "navbar.companhias": "Vállalatok",
    "navbar.information": "IOK információk",
    
    // FOOTERBAR
    "footerBar.menu": "Menü",
    "footerBar.cookbook": "Szakácskönyv",
    "footerBar.home": "Kezdőlap",
    "footerBar.menus": "Menük",
    "footerBar.notifications": "Értesítések",
    
    //MAP
    "map.título": "Helyszín",
    "map.erro": "Hiba!",
    "map.mensagem de erro": "Nem sikerült betölteni a térképet.",
    "map.Localização não disponível": "A helyadat nem érhető el",
    
    //MODAL
    "modal.CONFIRMAR": "MEGERŐSÍTÉS",
    "modal.Salvar alterações": "Módosítások mentése",
    "Modal.Há alterações não salvas nos parâmetros dos passos ": "A lépések paramétereiben nem mentett módosítások találhatók ",
    "Modal.Como deseja proceder?": "Hogyan szeretne továbblépni?",
    "Modal.Avaliar alterações realizadas": "Módosítások áttekintése",
    "Modal.Descartar alterações": "Módosítások elvetése",
    
    //USUÁRIOS
    "user.Nome": "Név",
    "user.E-mail": "E-mail",
    "user.Permissão": "Jogosultság",
    "user.Loja": "Üzlet",
    "user.Status": "Állapot",
    "user.Excluir": "Törlés",
    "user.Editar": "Szerkesztés",
    "user.Procurar usuário": "Felhasználó keresése",
    "user.ADICIONAR USUÁRIO": "FELHASZNÁLÓ HOZZÁADÁSA",
    "user.AINDA NÃO HÁ NENHUM USUÁRIO CADASTRADO :(": "MÉG NINCS REGISZTRÁLT FELHASZNÁLÓ :(",
    "user.+ Usuário": "+ Felhasználó",
    "user.Informe o nome do usuário": "Adja meg a felhasználó nevét",
    "user.Preencha o nome do usuário": "Töltse ki a felhasználó nevét",
    "user.Informe o e-mail do usuário": "Adja meg a felhasználó e-mail címét",
    "user.Preencha com um e-mail válido": "Adjon meg egy érvényes e-mail címet",
    "user.Administrador": "Adminisztrátor",
    "user.Usuário": "Felhasználó",
    "user.Preencha o telefone do usuário": "Töltse ki a felhasználó telefonszámát",
    "user.Selecione a permissão do usuário": "Válassza ki a felhasználó jogosultságát",
    "user.Ativo": "Aktív",
    "user.Inativo": "Inaktív",
    "user.Usuário deletado da plataforma com sucesso!": "A felhasználó sikeresen törölve lett a platformról!",
    "user.Ocorreu um erro. Tente novamente mais tarde": "Hiba történt. Kérjük, próbálja újra később",
    "user.EXCLUIR USUÁRIO": "FELHASZNÁLÓ TÖRLÉSE",
    "user.delete.paragrafo 1": "Biztosan törölni szeretné a felhasználót az IOK platformról?",
    "user.delete.paragrafo 2": "Ezzel elveszíti a hozzáférést a platform összes eszközéhez, hacsak később újra hozzá nem adják a regisztrációs folyamaton keresztül.",
    "user.EDITAR USUÁRIO": "FELHASZNÁLÓ SZERKESZTÉSE",
    "user.Usuário editado com sucesso!": "A felhasználó sikeresen módosítva!",
    "user.Não foi possível editar este usuário. Por favor, tente mais tarde": "Nem sikerült módosítani ezt a felhasználót. Kérjük, próbálja újra később",
    "user.INFORMAÇÕES DO USUÁRIO": "FELHASZNÁLÓI INFORMÁCIÓK",
    "user.Telefone": "Telefonszám",
    "user.Não foi possível cadastrar este usuário. Por favor, tente mais tarde": "Nem sikerült regisztrálni ezt a felhasználót. Kérjük, próbálja újra később",
    "user.Usuário adicionado com sucesso!": "A felhasználó sikeresen hozzáadva!",
    "user.CRIAR TIPO DE USUÁRIO": "FELHASZNÁLÓTÍPUS LÉTREHOZÁSA",
    "user.Criar novo tipo de usuário": "Új felhasználótípus létrehozása",
    "user.Adicionar novo usuário": "Új felhasználó hozzáadása",
    "user.Permissões": "Jogosultságok",
    "user.Preencha o nome do novo tipo de usuário": "Töltse ki az új felhasználótípus nevét",
    "user.Selecione pelo menos uma permissão": "Válasszon legalább egy jogosultságot",
    "user.Não foi possível carregar as permissões": "Nem sikerült betölteni a jogosultságokat",
    "user.Tipo de usuário criado com sucesso!": "A felhasználótípus sikeresen létrehozva!",
    "user.Não foi possível criar este novo tipo de usuário. Por favor, tente mais tarde": "Nem sikerült létrehozni ezt az új felhasználótípust. Kérjük, próbálja újra később",
    "user.Não foi possível carregar os tipos de usuário da companhia": "Nem sikerült betölteni a vállalat felhasználótípusait",
    "user.Tipo de usuário": "Felhasználótípus",
    "user.E-mail já cadastrado na plataforma. Informe um novo e-mail": "Ez az e-mail cím már regisztrálva van a platformon. Adjon meg egy másikat",
    "user.UNIR CONTAS": "FIÓKOK EGYESÍTÉSE",
    "user.ID da companhia": "Vállalat azonosítója",
    "user.Digite o ID da companhia que deseja unir a sua conta": "Adja meg annak a vállalatnak az azonosítóját, amelyet a fiókjához szeretne kapcsolni",
    "user.Preencha o ID da companhia": "Töltse ki a vállalat azonosítóját",
    "user.O administrador da outra conta poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.": "A másik fiók adminisztrátora a képernyő jobb felső sarkában található felhasználónevére kattintva találhatja meg az azonosítót.",
    "user.O administrador da outra conta receberá um e-mail para aceitar sua solicitação. Assim que for aceita, a união das duas contas será realizada!": "A másik fiók adminisztrátora e-mailt kap a kérelem elfogadásához. Amint elfogadja, a két fiók egyesítése megtörténik!",
    "user.Não foi possível solicitar a união de contas. Por favor, confirme o ID ou tente mais tarde": "Nem sikerült kérni a fiókok egyesítését. Kérjük, ellenőrizze az azonosítót vagy próbálja újra később",
    "user.SOLICITAÇÃO APROVADA COM SUCESSO": "A KÉRELEM SIKERESEN JÓVÁHAGYVA",
    "user.AGUARDE ENQUANTO REALIZAMOS A UNIÃO DAS CONTAS. ESTE PROCESSO PODE LEVAR ALGUNS MINUTOS...": "Kérjük, várjon, amíg egyesítjük a fiókokat. Ez a folyamat néhány percet igénybe vehet...",
    "user.UNIÃO DE CONTAS FINALIZADA COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "A FIÓKOK EGYESÍTÉSE SIKERESEN BEFEJEZŐDÖTT! KATTINTSON AZ ALÁBBI GOMBRA A PLATFORM ELÉRÉSÉHEZ.",
    "user.NÃO CONSEGUIMOS REALIZAR A UNIÃO DAS CONTAS. POR FAVOR, TENTE NOVAMENTE. SE O PROBLEMA PERSISTIR, ENTRE EM CONTATO COM NOSSO SUPORTE.": "Nem sikerült egyesíteni a fiókokat. Kérjük, próbálja újra. Ha a probléma továbbra is fennáll, lépjen kapcsolatba ügyfélszolgálatunkkal.",
    "user.possui todos os acessos": "minden hozzáféréssel rendelkezik",
    "user.possui o acesso das abas cookbook, meus menus e equipamentos": "hozzáfér a Szakácskönyv, Saját menük és Berendezések fülekhez",
    "user.possui apenas o acesso da aba cookbook": "csak a Szakácskönyv fülhöz fér hozzá",
    "user.possui apenas o acesso da aba equipamentos": "csak a Berendezések fülhöz fér hozzá",
    "user.possui apenas o acesso da aba meus menus": "csak a Saját menük fülhöz fér hozzá",
    "user.Grupo de equipamentos": "Berendezéscsoport",
    "user.Informe o telefone do usuário": "Adja meg a felhasználó telefonszámát",
    "user.Nenhum grupo criado": "Nincs létrehozott csoport",
    "user.Digite o ID da companhia que terá acesso à sua conta": "Adja meg annak a vállalatnak az azonosítóját, amely hozzáférést kap a fiókjához",
    "user.Ao informar um ID para unir contas com sua companhia, esteja ciente de que o novo usuário também se tornará Administrador da conta de sua companhia. É importante informar que a partir do momento em que um usuário aceitar unir contas com sua companhia, a companhia pertencente a ele deixará de existir.": "Ha megad egy azonosítót a vállalatával történő fiókegyesítéshez, vegye figyelembe, hogy az új felhasználó is a vállalat fiókjának adminisztrátora lesz. Fontos tudni, hogy amint egy felhasználó elfogadja a fiókegyesítést, az általa birtokolt vállalat megszűnik létezni.",
    "user.Exemplo: Sua conta: 001 | Outra conta: 111. Depois de unir contas com você, a outra conta passará a ser 001.": "Példa: Az Ön fiókja: 001 | Másik fiók: 111. Az egyesítés után a másik fiók is 001 lesz.",
    "user.Tela de Equipamentos": "Berendezések képernyő",
    "user.Tela de Meus Menus": "Saját menük képernyő",
    "user.Tela do Cookbook": "Szakácskönyv képernyő",
    "user.Tela de Usuários": "Felhasználók képernyő",
    "user.Aba de Suporte": "Támogatás fül",
    "user.Usuário Comum": "Normál felhasználó",
    "user.Usuário do Cookbook": "Szakácskönyv felhasználó",
    "user.Usuário de Equipamentos": "Berendezés felhasználó",
    "user.Usuário de Meus Menus": "Saját menük felhasználó",
    "user.Você deseja excluir seu acesso da plataforma IOK?": "Biztosan törölni szeretné az IOK platformhoz való hozzáférését?",
    "user.Ao fazer isso, você perderá o acesso a todas as ferramentas da plataforma e, para voltar a acessá-la, será necessário ser adicionado à ela novamente.": "Ezzel elveszíti a hozzáférést a platform összes eszközéhez, és az újbóli hozzáféréshez ismét hozzá kell adni a rendszerhez.",
    "user.CONFIRMAÇÃO": "MEGERŐSÍTÉS",
    "user.Confirme sua senha": "Erősítse meg a jelszavát",
    "user.Senha incorreta": "Helytelen jelszó",
    "user.Os equipamentos e menus criados por ele serão transferidos para o seu nome.": "Az általa létrehozott berendezések és menük az Ön nevére kerülnek át.",
    
    //TUTORIAIS 
    "tutorial.Fechar": "Bezárás",
    "tutorial.Fim": "Befejezés",
    "tutorial.Próximo": "Következő",
    "tutorial.Abrir": "Megnyitás",
    "tutorial.Pular tutorial": "Oktatóanyag kihagyása",
    "tutorial.Editar detalhes da receita": "Recept részleteinek szerkesztése",
    "tutorial.Agora você pode adicionar mais detalhes às suas receitas e deixá-las ainda mais completas. Clique em Editar detalhes e preencha as informações necessárias.": "Most további részleteket adhat receptjeihez, hogy még teljesebbek legyenek. Kattintson a Részletek szerkesztése lehetőségre, és töltse ki a szükséges információkat.",
    "tutorial.Salvar edição da receita": "Recept módosításainak mentése",
    "tutorial.Depois de informar mais detalhes da receita, clique em Salvar.": "Miután megadta a recept további részleteit, kattintson a Mentés gombra.",
    "tutorial.Editar registro de um equipamento": "Berendezés adatainak szerkesztése",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Categoria e Loja.": "A berendezések regisztrációjának befejezéséhez nyissa meg az oldalsó menüt, kattintson a Szerkesztés lehetőségre, és töltse ki a Kategória és Üzlet adatait.",
    "tutorial.Editar usuário": "Felhasználó szerkesztése",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente a Loja a qual ele faz parte.": "A felhasználók regisztrációjának befejezéséhez nyissa meg az oldalsó menüt, kattintson a Szerkesztés lehetőségre, és adja meg, melyik üzlethez tartozik.",
    "tutorial.Salvar edições de um equipamento": "Berendezés módosításainak mentése",
    "tutorial.Depois de completar o registro de seus equipamentos, clique em Salvar.": "Miután befejezte a berendezések regisztrációját, kattintson a Mentés gombra.",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em uma loja, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Egy üzlethez regisztrált berendezés sorára kattintva további statisztikákat és információkat tekinthet meg róla, valamint támogatást kérhet vagy frissítéseket küldhet.",
    "tutorial.Para visualizar mais informações sobre a loja, como localização e receitas mais preparadas, clique sobre a linha da unidade que deseja analisar.": "Az üzletről további információk – például helyszín és leggyakrabban futtatott receptek – megtekintéséhez kattintson az elemezni kívánt egység sorára.",
    "tutorial.Criar receita": "Recept létrehozása",
    "tutorial.No cookbook você pode criar suas próprias receitas! Clique em Criar Receita e preencha todas as informações necessárias.": "A Cookbookban saját recepteket is létrehozhat! Kattintson a Recept létrehozása lehetőségre, és töltse ki az összes szükséges adatot.",
    "tutorial.Editar ou excluir um usuário": "Felhasználó szerkesztése vagy törlése",
    "tutorial.Para excluir ou editar as informações de um usuário já cadastrado, clique no menu lateral e selecione a opção desejada.": "Egy már regisztrált felhasználó törléséhez vagy adatainak módosításához kattintson az oldalsó menüre, és válassza a kívánt lehetőséget.",
    "tutorial.Gerenciamento de usuários": "Felhasználókezelés",
    "tutorial.Aqui você pode gerenciar seus usuários com mais facilidade. Ao clicar em + Usuário, você poderá adicionar um novo usuário ou criar um novo tipo de usuário.": "Itt egyszerűbben kezelheti felhasználóit. A + Felhasználó gombra kattintva új felhasználót adhat hozzá vagy új felhasználói típust hozhat létre.",
    "tutorial.Suas receitas": "Saját receptjei",
    "tutorial.Pelo cookbook você também encontra suas próprias receitas, além de poder criá-las! Clique em Receitas Salvas para visualizar as receitas que foram salvas do cookbook da Prática e também as criadas por você.": "A Cookbookban saját receptjeit is megtalálja, valamint újakat is létrehozhat. Kattintson a Mentett receptek lehetőségre a Prática Cookbookból mentett és az Ön által létrehozott receptek megtekintéséhez.",
    "tutorial.Filtros do Cookbook": "Cookbook szűrők",
    "tutorial.Para facilitar a navegação pelas receitas, você pode aplicar filtros a elas. Basta clicar no filtro desejado e escolher uma de suas opções.": "A receptek közötti könnyebb navigáció érdekében szűrőket alkalmazhat. Csak kattintson a kívánt szűrőre, és válasszon egy lehetőséget.",
    "tutorial.Cookbook": "Cookbook",
    "tutorial.No cookbook, em Receitas Disponíveis, você encontrará as receitas criadas pelos Chefs da Prática e poderá utilizá-las sempre que quiser.": "A Cookbook Elérhető receptek részében a Prática séfjei által készített recepteket találja, amelyeket bármikor felhasználhat.",
    "tutorial.Atualizar equipamentos": "Berendezések frissítése",
    "tutorial.Para enviar uma atualização a seus equipamentos, clique em Atualizar Equipamentos, selecione os modelos que deseja atualizar e a forma como deseja realizar essa atualização - via wi-fi ou pen drive. Depois disso, clique em Confirmar.": "A berendezések frissítéséhez kattintson a Berendezések frissítése lehetőségre, válassza ki a frissítendő modelleket és a frissítés módját (Wi-Fi vagy USB-meghajtó), majd kattintson a Megerősítés gombra.",
    "tutorial.Adicionar equipamento": "Berendezés hozzáadása",
    "tutorial.Para adicionar um equipamento à sua conta, clique em Adicionar Equipamento e preencha as informações do modal. Depois disso, clique em Salvar.": "Berendezés hozzáadásához kattintson a Berendezés hozzáadása lehetőségre, töltse ki az ablakban megjelenő adatokat, majd kattintson a Mentés gombra.",
    "tutorial.Editar equipamento": "Berendezés szerkesztése",
    "tutorial.Para desvincular um equipamento ou editar suas informações, clique no menu lateral e selecione a opção desejada.": "Egy berendezés leválasztásához vagy adatainak szerkesztéséhez kattintson az oldalsó menüre, és válassza a kívánt lehetőséget.",
    "tutorial.Seus equipamentos": "Saját berendezései",
    "tutorial.Aqui você visualizará todos os equipamentos cadastrados em sua plataforma.": "Itt megtekintheti a platformon regisztrált összes berendezést.",
    "tutorial.Restaurar arquivos": "Fájlok visszaállítása",
    "tutorial.Para restaurar um arquivo excluído ou deletá-lo permanentemente, clique no menu lateral e selecione a opção desejada.": "Törölt fájl visszaállításához vagy végleges törléséhez kattintson az oldalsó menüre, és válassza a kívánt lehetőséget.",
    "tutorial.Lixeira": "Kuka",
    "tutorial.Os menus excluídos serão mantidos na Lixeira por 30 dias. Depois desse prazo serão excluídos permanentemente.": "A törölt menük 30 napig a Kukában maradnak. Ezt követően véglegesen törlésre kerülnek.",
    "tutorial.Salvar edições de usuário": "Felhasználói módosítások mentése",
    "tutorial.Depois de completar o cadastro dos usuários, clique em Salvar.": "Miután befejezte a felhasználók regisztrációját, kattintson a Mentés gombra.",
    "tutorial.Criar menu": "Menü létrehozása",
    "tutorial.Para criar e personalizar um menu, clique em Criar Menu e preencha as informações necessárias no modal. Você pode editar um menu a qualquer momento.": "Menü létrehozásához és testreszabásához kattintson a Menü létrehozása lehetőségre, és töltse ki a szükséges adatokat. A menü bármikor szerkeszthető.",
    "tutorial.Importar menu": "Menü importálása",
    "tutorial.Para importar um menu, clique em Importar Menu e selecione o modelo e versão do equipamento.": "Menü importálásához kattintson a Menü importálása lehetőségre, majd válassza ki a berendezés modelljét és verzióját.",
    "tutorial.Criar grupo": "Csoport létrehozása",
    "tutorial.Para organizar suas receitas em grupos, clique em Criar Grupo e preencha as informações necessárias no modal.": "Receptek csoportokba rendezéséhez kattintson a Csoport létrehozása lehetőségre, és töltse ki a szükséges adatokat a felugró ablakban.",
    "tutorial.Tipos de usuário": "Felhasználótípusok",
    "tutorial.Agora você também pode criar tipos de usuários com permissões específicas para atender melhor a sua organização.": "Most már egyedi jogosultságokkal rendelkező felhasználótípusokat is létrehozhat, hogy jobban megfeleljen szervezete igényeinek.",
    "tutorial.Gerenciamento de contas": "Fiókkezelés",
    "tutorial.Se caso outra pessoa da sua organização também migrou a conta principal da empresa, aqui você pode unir as duas contas.": "Ha a szervezetében valaki más is migrálta a vállalat fő fiókját, itt egyesítheti a két fiókot.",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Grupo.": "A berendezések regisztrációjának befejezéséhez nyissa meg az oldalsó menüt, kattintson a Szerkesztés lehetőségre, és töltse ki a Csoport adatait.",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente ao Grupo de equipamentos a qual ele faz parte.": "A felhasználók regisztrációjának befejezéséhez nyissa meg az oldalsó menüt, kattintson a Szerkesztés lehetőségre, és adja meg, hogy melyik berendezéscsoporthoz tartoznak.",
    "tutorial.Grupos de equipamentos": "Berendezéscsoportok",
    "tutorial.Na aba Grupos você pode visualizar os grupos cadastrados e os equipamentos distribuídos entre eles. Além disso, é possível cadastrar novos grupos e editar os já cadastrados.": "A Csoportok fülön megtekintheti a létrehozott csoportokat és a hozzájuk rendelt berendezéseket. Emellett új csoportokat is létrehozhat, illetve módosíthatja a meglévőket.",
    "tutorial.Detalhes de grupos": "Csoport részletei",
    "tutorial.Para visualizar mais informações sobre o grupo, como localização e receitas mais preparadas, clique sobre a linha que deseja analisar.": "A csoportról további információk – például helyszín és leggyakrabban futtatott receptek – megtekintéséhez kattintson a kívánt sorra.",
    "tutorial.Equipamentos em grupos": "Berendezések csoportokban",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em um grupo, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Egy csoporthoz tartozó berendezés sorára kattintva további statisztikákat és információkat tekinthet meg róla, valamint támogatást kérhet vagy frissítéseket küldhet.",
    "tutorial.Grupos": "Csoportok",
    "tutorial.Atualização e cache": "Frissítés és gyorsítótár",
    "tutorial.Para atualizar a plataforma e corrigir eventuais problemas de cache, clique aqui.": "A platform frissítéséhez és az esetleges gyorsítótár-problémák megoldásához kattintson ide.",
    "tutorial.Dados dos equipamentos": "Berendezések adatai",
    "tutorial.Ao clicar sobre a linha de um equipamento, você pode visualizar mais estatísticas e informações sobre ele, como as receitas mais preparadas, limpezas realizadas e outros dados relevantes.": "Egy berendezés sorára kattintva további statisztikákat és információkat tekinthet meg róla, például a leggyakrabban futtatott recepteket, az elvégzett tisztításokat és egyéb releváns adatokat.",
    "tutorial.Para alterar o idioma de sua plataforma, clique em Idioma e selecione a linguagem desejada.": "A platform nyelvének módosításához kattintson a Nyelv lehetőségre, majd válassza ki a kívánt nyelvet.",
    "tutorial.Alterar idioma": "Nyelv módosítása",
    "tutorial.Para editar ou configurar sua conta, clique em seu nome e selecione a opção desejada.": "Fiókja szerkesztéséhez vagy beállításához kattintson a nevére, majd válassza ki a kívánt lehetőséget.",
    "tutorial.Editar conta": "Fiók szerkesztése",
    "tutorial.Total de Usuários Cadastrados em sua conta.": "A fiókjában regisztrált felhasználók teljes száma.",
    "tutorial.Home": "Kezdőlap",
    "tutorial.Localização de seus equipamentos, sendo possível expandir o mapa para melhor visualização;": "Berendezéseinek helyzete, a térkép nagyítható a jobb áttekinthetőség érdekében;",
    "tutorial.Atualizações referentes a versão dos equipamentos vinculados a sua conta;": "A fiókjához kapcsolt berendezések verziófrissítései;",
    "tutorial.Total de Receitas Cadastradas;": "Regisztrált receptek összesen;",
    "tutorial.Menus Disponíveis;": "Elérhető menük;",
    "tutorial.Esta é a sua home! Aqui você encontra um resumo geral sobre sua conta;" : "Ez a kezdőoldalad! Itt megtalálod a fiókod általános összefoglalóját;",
    "tutorial.Clique nas abas do menu para explorar a plataforma e conhecer tudo o que ela pode oferecer.": "Kattintson a menüfülekre a platform felfedezéséhez és az összes elérhető funkció megismeréséhez.",
    "tutorial.Exportar menu": "Menü exportálása",
    "tutorial.Depois de personalizar seu menu, exporte-o para seus equipamentos pela internet ou por pen drive.": "A menü testreszabása után exportálja azt a berendezéseire interneten vagy USB-meghajtón keresztül.",
    "tutorial.Na aba Localização você pode visualizar os endereços já cadastrados, além de criar localizações precisas para vincular seus equipamentos a elas.": "A Helyszín fülön megtekintheti a már regisztrált címeket, valamint pontos helyszíneket hozhat létre berendezései hozzárendeléséhez.",
    "tutorial.Localização": "Helyszín",
    "tutorial.Informações sobre o equipamento": "Információk a berendezésről",
    "tutorial.Equipamentos Ligados e quantos estão enviando dados de uso;" : "Csatlakoztatott berendezések és azok száma, amelyek használati adatokat küldenek;",
    
    //RECOVER ACCOUNT
    "recoverAccount.Para prosseguir, selecione a categoria na qual você se encaixa:": "A folytatáshoz válassza ki az Önre vonatkozó kategóriát:",
    "recoverAccount.Deseja acessar a plataforma como DISTRIBUIDOR? Crie sua conta clicando em EMPRESA e entre em contato conosco para liberarmos os demais acessos.": "Forgalmazóként szeretne hozzáférni a platformhoz? Hozza létre fiókját a VÁLLALAT lehetőségre kattintva, majd vegye fel velünk a kapcsolatot, hogy engedélyezhessük a további hozzáféréseket.",
    "recoverAccount.A qual organização você pertence": "Melyik szervezethez tartozik?",
    
    //RECOVER PASSWORD PAGE
    "recoverPassword.E-mail para recuperação de senha": "Jelszó-helyreállítási e-mail",
    "recoverPassword.Informe o e-mail cadastrado na plataforma": "Adja meg a platformon regisztrált e-mail címét",
    "recoverPassword.E-mail inválido. Por favor, verifique": "Érvénytelen e-mail cím. Kérjük, ellenőrizze",
    "recoverPassword.RECUPERAR SENHA": "JELSZÓ HELYREÁLLÍTÁSA",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL COM O LINK DE RECUPERAÇÃO DE SENHA": "HAMAROSAN KAP EGY E-MAILT A JELSZÓ HELYREÁLLÍTÁSÁHOZ SZÜKSÉGES HIVATKOZÁSSAL",
    "recoverPassword.Informe seu e-mail": "Adja meg az e-mail címét",
    "recoverPassword.Crie uma nova senha": "Hozzon létre egy új jelszót",
    "recoverPassword.O campo senha deve conter no mínimo 6 caracteres": "A jelszó mezőnek legalább 6 karakterből kell állnia",
    "recoverPassword.Confirme sua senha": "Erősítse meg a jelszavát",
    "recoverPassword.As senhas devem ser iguais": "A jelszavaknak egyezniük kell",
    "recoverPassword.ENTRAR": "BEJELENTKEZÉS",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL PARA CONFIRMAR SUA IDENTIDADE": "HAMAROSAN KAP EGY E-MAILT SZEMÉLYAZONOSSÁGÁNAK MEGERŐSÍTÉSÉHEZ",
    "recoverPassword.CONTINUAR": "FOLYTATÁS",
    "recoverPassword.CONFIRMAR": "MEGERŐSÍTÉS",
    "recoverPassword.Por segurança, o acesso à conta foi bloqueado devido a tentativas de login incorretas.": "Biztonsági okokból a fiókhoz való hozzáférés zárolva lett a sikertelen bejelentkezési kísérletek miatt.",
    "recoverPassword.Para desbloquear sua conta, siga as instruções após clicar no botão abaixo:": "A fiók feloldásához kövesse az alábbi gombra kattintás után megjelenő utasításokat:",
    "recoverPassword.Desbloquear conta": "Fiók feloldása",
    "recoverPassword.Você recebeu um e-mail para iniciar o desbloqueio de sua conta.": "Kapott egy e-mailt a fiók feloldásának megkezdéséhez.",
    "recoverPassword.Verifique sua caixa de entrada ou spam.": "Ellenőrizze a beérkezett üzenetek vagy a spam mappát.",
    "recoverPassword.Verifique seu e-mail": "Ellenőrizze az e-mailjeit",
    "recoverPassword.Informe seu e-mail de login e crie uma nova senha para acessar sua conta.": "Adja meg a bejelentkezési e-mail címét, és hozzon létre egy új jelszót a fiókjához való hozzáféréshez.",
    
    // EXPORT
    "export.Limpezas": "Tisztítások",
    "export.Eventos": "Események",
    "export.Lista de receitas preparadas": "Végrehajtott receptek listája",
    "export.Lista de limpezas realizadas": "Elvégzett tisztítások listája",
    "export.Lista de eventos ocorridos": "Bekövetkezett események listája",
    "export.Exportar dados": "Adatok exportálása",
    "export.Exportar": "Exportálás",
    "export.Informações do equipamento": "Berendezés adatai",
    "export.Dados exportados com sucesso!": "Az adatok exportálása sikeresen megtörtént!",
    "export.Não foi possível exportar os dados. Por favor, tente novamente mais tarde.": "Nem sikerült exportálni az adatokat. Kérjük, próbálja újra később.",
    "export.Detalhes do menu": "Menü részletei",
    "export.Detalhes de receitas": "Receptrészletek",
    "export.Detalhes e Passos": "Részletek és lépések",
    "export.Exportando dados. Em breve o arquivo estará disponível!": "Az adatok exportálása folyamatban van. A fájl hamarosan elérhető lesz!",
    "export.Resumo dos passos": "Lépések összefoglalása",
    "export.salvar imagem": "kép mentése",
    "export.Nenhum modelo foi selecionado": "Nincs kiválasztott modell",
    
    // COMPANIES PAGE
    "company.Procurar companhia": "Vállalat keresése",
    "company.Adicionar companhia": "Vállalat hozzáadása",
    "company.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "MÉG NINCS REGISZTRÁLT VÁLLALAT :(",
    "company.description.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "Kattintson a jobb felső sarokban található gombra, és adjon hozzá vállalatokat.",
    "company.Adicionar": "Hozzáadás",
    "company.ADICIONAR EQUIPAMENTOS": "BERENDEZÉSEK HOZZÁADÁSA",
    "company.Preencha pelo menos um número de série": "Adjon meg legalább egy sorozatszámot",
    "company.Informe os números de série": "Adja meg a sorozatszámokat",
    "company.Número de série": "Sorozatszám",
    "company.Para incluir vários equipamentos, separe-os com ponto e vírgula (;).": "Több berendezés hozzáadásához válassza el őket pontosvesszővel (;).",
    "company.Informe o número de série do equipamento que deseja adicionar abaixo.": "Adja meg az alább hozzáadni kívánt berendezés sorozatszámát.",
    "company.Números de série adicionados com sucesso!": "A sorozatszámok sikeresen hozzáadva!",
    "company.Não foi possível adicionar os números de série. Tente novamente mais tarde": "Nem sikerült hozzáadni a sorozatszámokat. Kérjük, próbálja újra később.",
    "company.adicionar": "hozzáadás",
    "company.Procurar por companhia ou ID": "Keresés vállalat vagy azonosító alapján",
    "company.Companhia": "Vállalat",
    "company.E-mail principal": "Elsődleges e-mail",
    "company.Local": "Helyszín",
    "company.Companhia adicionada com sucesso!": "A vállalat sikeresen hozzáadva!",
    "company.Não foi possível cadastrar a companhia": "Nem sikerült regisztrálni a vállalatot",
    "company.REMOVER COMPANHIA": "VÁLLALAT ELTÁVOLÍTÁSA",
    "company.Você deseja remover a companhia definitivamente? Os equipamentos vinculados a ela também serão removidos de sua conta.": "Biztosan véglegesen el szeretné távolítani a vállalatot? A hozzá kapcsolódó berendezések is eltávolításra kerülnek a fiókjából.",
    "company.Esta ação não poderá ser desfeita.": "Ez a művelet nem vonható vissza.",
    "company.A companhia foi removida com sucesso!": "A vállalat sikeresen eltávolítva!",
    "company.Não foi possível remover a companhia": "Nem sikerült eltávolítani a vállalatot",
    "company.Quant. de fornos": "Kemencék száma",
    "company.Fornos conectados": "Csatlakoztatott kemencék",
    "company.Fornos não conectados": "Nem csatlakoztatott kemencék",
    "company.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "MÉG NINCS REGISZTRÁLT BERENDEZÉS :(",
    "company.description.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "Kattintson a jobb felső sarokban található gombra, és adjon hozzá berendezéseket.",
    "company.Procurar número de série": "Sorozatszám keresése",
    "company.excluir equipamento": "berendezés törlése",
    "company.Você deseja excluir o equipamento selecionado definitivamente?": "Biztosan véglegesen törölni szeretné a kiválasztott berendezést?",
    "company.Número de série editado com sucesso!": "A sorozatszám sikeresen módosítva!",
    "company.Não foi possível editar o número de série. Tente novamente mais tarde": "Nem sikerült módosítani a sorozatszámot. Kérjük, próbálja újra később.",
    "company.Informe o número de série": "Adja meg a sorozatszámot",
    "company.Preencha um número de série": "Töltse ki a sorozatszámot",
    "company.EDITAR EQUIPAMENTO": "BERENDEZÉS SZERKESZTÉSE",
    "company.Modelo": "Modell",
    "company.Cadastro": "Regisztráció",
    "company.Conectado": "Csatlakoztatva",
    "company.SELECIONE EQUIPAMENTOS PARA EXCLUIR": "VÁLASSZA KI A TÖRLENDŐ BERENDEZÉSEKET",
    "company.O equipamento foi removida com sucesso!": "A berendezés sikeresen eltávolítva!",
    "company.Não foi possível remover o equipamento": "Nem sikerült eltávolítani a berendezést",
    "company.Caracteres especiais não são permitidos, exceto o ponto e vírgula (';')": "Különleges karakterek nem engedélyezettek, kivéve a pontosvesszőt (';')",
    "company.Preencha o número de série sem caracteres especiais": "Adja meg a sorozatszámot különleges karakterek nélkül",
    "company.Um ou mais números de série já estão provisionados para outra companhia": "Egy vagy több sorozatszám már egy másik vállalathoz van hozzárendelve.",
    "company.Um ou mais números de série já estão conectados na conta de outra companhia": "Egy vagy több sorozatszám már egy másik vállalat fiókjához van csatlakoztatva.",
    
    // Error
    "error.Ocorreu um erro ao carregar esta seção": "Hiba történt a szakasz betöltése közben",
    "error.Tentar novamente": "Próbálja újra",
    
    //DASHBOARDS
    "dashboard.fornos vinculados": "Összekapcsolt sütők",
    "dashboard.ativos": "Aktív",
    "dashboard.inativos": "Inaktív",
    "dashboard.sem status": "Nincs állapot",
    "dashboard.fornos atualizados": "FRISSÍTETT SÜTŐK",
    "dashboard.com a versão do software mais recente": "A legfrissebb szoftververzióval",
    "dashboard.chamados": "HIBAJEGYEK",
    "dashboard.veja mais no app cliente": "Továbbiak megtekintése az Ügyfél alkalmazásban",
    "dashboard.limpeza diária": "NAPI TISZTÍTÁS",
    "dashboard.dos fornos estão em dia": "a sütők naprakészek",
    "dashboard.top 3": "Top 3",
    "dashboard.média de execuções de receitas por hora": "Receptfuttatások átlagos száma óránként",
    "dashboard.avisos": "ÉRTESÍTÉSEK",
    "dashboard.sem avisos por aqui": "NINCSENEK ÉRTESÍTÉSEK",
    "dashboard.ver mais": "Továbbiak",
    "dashboard.abertos pela plataforma IOK": "Az IOK platform által megnyitva",
    "dashboard.equipamentos": "Berendezések",
    "dashboard.receitas": "Receptek",
    "dashboard.executada": "végrehajtva",
    "dashboard.vezes": "alkalommal",
    "dashboard.forno": "Sütő",
    "dashboard.média por hora": "Óránkénti átlag",
    "dashboard.editar": "szerkesztés",
    "dashboard.endereço:": "Cím:",
    "dashboard.cep:": "Irányítószám:",
    "dashboard.estatísticas": "Statisztikák",
    "dashboard.uso de equipamento": "Berendezés használata",
    "dashboard.pico de uso": "Csúcshasználat",
    "dashboard.receitas mais executadas por equipamento": "Leggyakrabban futtatott receptek berendezésenként",
    "dashboard.recolher": "összecsukás",
    "dashboard.TOROS TC CONECTADOS:": "CSATLAKOZTATOTT TOROS TC:",
    "dashboard.Consumo de energia - Lastro Toro TC": "Energiafogyasztás - Toro TC sütőlap",
    "dashboard.tootilp": "Az aktuális napon végrehajtott összes recept összege, elosztva a sütő bekapcsolt állapotban töltött óráinak számával.",
    "dashboard.noResults": "Nincs találat :(",
    "dashboard.Preaquecimento": "Előmelegítés",
    "dashboard.Esfriamento": "Hűtés",
    "dashboard.Execução de receitas": "Receptek végrehajtása",
    "dashboard.Execução de receitas TSi": "TSi receptek végrehajtása",
    "dashboard.Modo manual": "Kézi mód",
    "dashboard.Limpeza": "Tisztítás",
    "dashboard.Porta": "Ajtó",
    "dashboard.Erros e alertas": "Hibák és figyelmeztetések",
    "dashboard.Parâmetros": "Paraméterek",
    "dashboard.SEM DADOS POR AQUI": "NINCSENEK ADATOK",
    "dashboard.AINDA SEM GRÁFICOS POR AQUI": "MÉG NINCSENEK GRAFIKONOK",
    "dashboard.description.AINDA SEM GRÁFICOS POR AQUI": "Válasszon elemeket a jobb oldali listából a grafikonok létrehozásához, vagy kattintson egy sorra a részletesebb információk megtekintéséhez.",
    
    //INFORMAÇÕES IOK
    "iokInformation.search.placeholder": "Cikk keresése",
    "iokInformation.article.openInHelpCenter": "Cikk megtekintése a Súgóközpontban",
    "iokInformation.aboutPlatform.platformFeatures.title": "A platform és annak funkciói",
    "iokInformation.aboutPlatform.platformFeatures.linkLabel": "Teljes bemutató letöltése",
    "iokInformation.aboutPlatform.manual.title": "Használati útmutató",
    "iokInformation.aboutPlatform.manual.linkLabel": "Útmutató letöltése",
    "iokInformation.aboutPlatform.privacy.title": "Adatvédelmi szabályzat",
    "iokInformation.aboutPlatform.privacy.linkLabel": "Szabályzat letöltése",
    "iokInformation.aboutPlatform.api.title": "Külső API",
    "iokInformation.aboutPlatform.api.linkLabel": "Dokumentum letöltése",
    
    //Telemetry TSI
    "telemetry.EQUIPMENT_TURN_ON": "Berendezés bekapcsolva",
    "telemetry.SENSORS_VALUES": "Szenzorértékek",
    "telemetry.ERROR_DETECTED": "Hiba észlelve",
    "telemetry.TIME_ADDED": "Idő hozzáadva",
    "telemetry.GN_ADDED": "GN hozzáadva",
    "telemetry.GN_RELEASED": "GN elindítva",
    "telemetry.GN_FINISHED": "GN befejezve",
    
    "telemetry.HEAVY_CLEANING_CANCELED": "Intenzív tisztítás megszakítva",
    "telemetry.CLEANING_CANCELED": "Tisztítás megszakítva",
    "telemetry.CLEANING_RESTARTED": "Tisztítás újraindítva",
    "telemetry.CLEANING_VAPORIZATION_STEP": "Párologtatási lépés a tisztítás során",
    "telemetry.CLEANING_SUPPLY_STEP": "Feltöltési lépés a tisztítás során",
    "telemetry.CLEANING_CIRCULATION_STEP": "Keringtetési lépés a tisztítás során",
    "telemetry.CLEANING_DEPLETION_STEP": "Leürítési lépés a tisztítás során",
    "telemetry.CLEANING_RISING_STEP": "Öblítési lépés a tisztítás során",
    "telemetry.CLEANING_STARTED": "Tisztítás elindítva",
    "telemetry.CLEANING_FINISHED": "Tisztítás befejezve",
    "telemetry.RECOMMENDED_CLEANING": "Ajánlott tisztítás",
    "telemetry.VALID_PASSWORD_CLEANING": "Érvényes jelszó a tisztítás során",
    "telemetry.INVALID_PASSWORD_CLEANING": "Érvénytelen jelszó a tisztítás során",
    
    "telemetry.RECIPE_STARTED": "Recept elindítva",
    "telemetry.RECIPE_FINISHED": "Recept befejezve",
    "telemetry.RECIPE_CANCELED": "Recept megszakítva",
    "telemetry.RECIPE_STEP_CHANGED": "Receptlépés módosítva",
    "telemetry.RECIPE_PAUSED": "Recept szüneteltetve",
    "telemetry.RECIPE_RESUMED": "Recept folytatva",
    "telemetry.DROP_ENERGY_SUPPLY": "Folytatás áramszünet után",
    "telemetry.RESUME_RECIPE_CANCELED": "A recept folytatása megszakítva",
    
    "telemetry.PRE_HEAT_STARTED": "Előmelegítés elindítva",
    "telemetry.PRE_HEAT_FINISHED": "Előmelegítés befejezve",
    "telemetry.OPERATION_CONTINUE_STARTED": "Művelet folytatása elindítva",
    "telemetry.OPERATION_CONTINUE_FINISHED": "Művelet folytatása befejezve",
    "telemetry.HOLD_TEMPERATURE_STARTED": "Hőmérséklet-tartás elindítva",
    "telemetry.HOLD_TEMPERATURE_FINISHED": "Hőmérséklet-tartás befejezve",
    "telemetry.COOL_DOWN_STARTED": "Hűtés elindítva",
    "telemetry.COOL_DOWN_FINISHED": "Hűtés befejezve",
    "telemetry.NOCTURNAL_COOKING_STARTED": "Éjszakai sütés elindítva",
    "telemetry.NOCTURNAL_COOKING_FINISHED": "Éjszakai sütés befejezve",
    "telemetry.SEALING_STARTED": "Kérgesítés elindítva",
    "telemetry.SEALING_FINISHED": "Kérgesítés befejezve",
    "telemetry.TURBO_GRILL_STARTED": "Turbo Grill elindítva",
    "telemetry.TURBO_GRILL_FINISHED": "Turbo Grill befejezve",
    "telemetry.TURBO_GRILL_ACTIVATED": "Turbo Grill aktiválva",
    "telemetry.TURBO_GRILL_DISABLED": "Turbo Grill kikapcsolva",
    
    "telemetry.MOISTURE_CHANGED": "Páratartalom módosítva",
    "telemetry.TURBINE_CHANGED": "Ventilátor értéke módosítva",
    "telemetry.SET_POINT_CHANGED": "Kamrahőmérséklet módosítva",
    "telemetry.STEAM_CHANGED": "Gőz módosítva",
    "telemetry.PROBE_CHANGED": "Maghőmérséklet módosítva",
    "telemetry.TIME_CHANGED": "Idő módosítva",
    "telemetry.DOOR_OPENED": "Ajtó nyitva",
    "telemetry.DOOR_CLOSED": "Ajtó zárva",
    
    "telemetry.PROBE_CONTROL_SELECTED": "Maghőmérséklet-alapú vezérlés kiválasztva",
    "telemetry.TIME_CONTROL_SELECTED": "Időalapú vezérlés kiválasztva",
    "telemetry.MANUAL_STEAM_INJECTED": "Kézi gőzbefecskendezés",
    "telemetry.AUTOMATIC_STEAM_INJECTED": "Automatikus gőzbefecskendezés",
    
    "telemetry.DATABASE_CREATED": "Adatbázis létrehozva",
    "telemetry.EXIT_FUNCTION": "Funkció befejezve",
    "telemetry.CONSUMPTION": "Fogyasztás",
    "telemetry.STANDBY": "Készenléti állapot",
    
    "telemetry.ANALYTICS_ERROR_BAD_REQUEST": "Analytics hiba: Érvénytelen kérés",
    "telemetry.ANALYTICS_ERROR_FORBIDDEN": "Analytics hiba: Hozzáférés megtagadva",
    "telemetry.ANALYTICS_ERROR_SERVER": "Analytics hiba: Szerverhiba",
    "telemetry.ANALYTICS_ERROR_UNEXPECTED": "Analytics hiba: Váratlan hiba",
    "telemetry.ANALYTICS_SUCCESS": "Analytics sikeres",
    
    "telemetry.STEP": "Lépés",
    "telemetry.STEAM": "Gőz",
    "telemetry.PROBE": "Maghőmérő",
    "telemetry.TURBINE": "Ventilátor",
    "telemetry.OCCURRENCES": "előfordulás",
    "telemetry.FUNC_USER_RECIPE": "Felhasználói recept",
    "telemetry.FUNC_TSI_RECIPE": "TSi recept",
    "telemetry.FUNC_DELTA_T": "Delta T",
    "telemetry.FUNC_STEAM": "Gőz",
    "telemetry.FUNC_COMBINED_STEAM": "Kombinált gőz",
    "telemetry.FUNC_HOT_AIR": "Forró levegő",
    "telemetry.FUNC_NOCTURNAL_COOKING": "Éjszakai sütés",
    "telemetry.FUNC_REGENERATE": "Regenerálás",
    "telemetry.FUNC_MULTIPLE_COOKING": "Többszörös sütés",
    
    "haccp.filterBy": "Szűrés",
    "haccp.export.generating": "A HACCP táblázat készül, és hamarosan automatikusan letöltődik.",
    "haccp.voltage": "Feszültség",
    "haccp.voltageReading": "Feszültségmérés",
    "haccp.voltageOscillation": "Napi feszültségingadozás",
    "haccp.status.normal": "Normál",
    "haccp.status.attention": "Figyelem",
    "haccp.status.critical": "Kritikus",
    "haccp.dateTime": "Dátum/Idő",
    "haccp.errorDetected": "Észlelt hiba/figyelmeztetés",
    "haccp.detected": "észlelve",
    "haccp.errorTypeLabel": "Hiba/figyelmeztetés típusa",
    "haccp.severityLabel": "Súlyosság",
    "haccp.severity.error": "Hiba",
    "haccp.severity.alert": "Figyelmeztetés",
    "haccp.error.canNetwork": "CAN hálózati hiba",
    "haccp.error.chamberSensor": "Kamraérzékelő hiba",
    "haccp.error.steamSensor": "Gőzérzékelő hiba",
    "haccp.error.probeSensor": "Maghőmérő hiba",
    "haccp.error.noWater": "Vízhiány hiba",
    "haccp.error.panelTemp": "Panelhőmérséklet hiba",
    "haccp.error.motor": "Motorhiba",
    "haccp.error.motorComm": "Motor kommunikációs hiba",
    "haccp.error.hygieneIncomplete": "Befejezetlen tisztítási hiba",
    "haccp.error.familyModel": "Termékcsalád/modell hiba",
    "haccp.error.boardTemp": "Panelhőmérséklet hiba",
    "haccp.error.energyModule": "Energia modul hiba",
    "haccp.error.i2c": "I2C hiba",
    "haccp.error.gas": "Gázhiba",
    "haccp.loading": "Betöltés...",
    "haccp.quantity": "Mennyiség",
    "haccp.executions": "Végrehajtások",
    "haccp.manual.mode": "Mód",
    "haccp.manual.tempC": "Hőm. (°C)",
    "haccp.manual.timeMin": "Idő (perc)",
    "haccp.manual.probeC": "Maghőmérő (°C)",
    "haccp.manual.steamPct": "Gőz %",
    "haccp.cleaning.label": "Tisztítás",
    "haccp.cleaning.recommendedLabel": "Ajánlott tisztítás",
    "haccp.cleaning.status.completed": "Befejezve",
    "haccp.cleaning.status.restarted": "Újraindítva",
    "haccp.cleaning.status.interrupted": "Megszakítva",
    "haccp.status.label": "Állapot",
    "haccp.error": "Hiba",
    "haccp.consumption.water": "Vízfogyasztás",
    "haccp.consumption.energy": "Energiafogyasztás",
    "haccp.short.temp": "Hőm.",
    "haccp.short.time": "Idő",
    "haccp.day": "Nap",
    "haccp.recipeExecutions": "Végrehajtások száma",
    "STEAM": "Gőz",
    "COMBINED_STEAM": "Kombinált gőz",
    "PROBE": "Maghőmérő",
    "TURBINE": "Ventilátor",
    "HOT_AIR": "Forró levegő",
    "NOCTURNAL_COOKING": "Éjszakai sütés",
    "REGENERATE": "Regenerálás",
    "MULTIPLE_COOKING": "Többszörös sütés",
    "DELTA_T": "Delta T",
    
    //CSAT
    "csat.AVALIE SUA EXPERIÊNCIA": "ÉRTÉKELJE TAPASZTALATÁT",
    "csat.Como você avalia sua experiência com": "Hogyan értékeli a következővel kapcsolatos tapasztalatát:",
    "csat.Muito insatisfeito": "Nagyon elégedetlen",
    "csat.Insatisfeito": "Elégedetlen",
    "csat.Neutro": "Semleges",
    "csat.Satisfeito": "Elégedett",
    "csat.Muito satisfeito": "Nagyon elégedett",
    "csat.Utilize o espaço abaixo para deixar suas sugestões:": "Használja az alábbi mezőt javaslatainak megadásához:",
    "csat.Digite aqui": "Írjon ide",
    "csat.Obrigado por responder à nossa pesquisa!": "Köszönjük, hogy kitöltötte kérdőívünket!",
    "csat.Selecione uma nota para continuar": "A folytatáshoz válasszon egy értékelést",
    "csat.Enviar": "Küldés",
    "csat.a criação de receitas": "receptek létrehozása",
    "csat.o cadastro de equipamentos": "berendezések regisztrálása",
    "csat.o cadastro de usuários": "felhasználók regisztrálása",
    "csat.a criação de menus": "menük létrehozása",
    "csat.a deleção de receitas": "receptek törlése",
    "csat.a reordenação de receitas": "receptek átrendezése",
    "csat.o envio de software": "szoftver küldése",
    "csat.o envio de menus": "menük küldése",
    "csat.o uso de receitas do Cookbook": "a Cookbook receptek használata"
    
  },
};

export default hu;


